import * as React from "react";

function SvgComponent(props) {
    return (
        <svg version="1.1" id="Layer_1" xmlns="https://www.w3.org/2000/svg" x="0px" y="0px"
            width="90%" height="80%" viewBox="0 0 4000 743" >
            <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="
M2031.000000,744.000000 
	C1354.000000,744.000000 677.500000,744.000000 1.000000,744.000000 
	C1.000000,496.333344 1.000000,248.666672 1.000000,1.000000 
	C1044.333374,1.000000 2087.666748,1.000000 3131.000000,1.000000 
	C3131.000000,248.666672 3131.000000,496.333344 3131.000000,744.000000 
	C2764.500000,744.000000 2398.000000,744.000000 2031.000000,744.000000 
M2653.696045,134.133743 
	C2652.143799,134.051712 2650.591553,133.969681 2648.397949,133.469345 
	C2637.946045,132.337708 2627.493896,131.206070 2616.545898,129.587555 
	C2615.039062,130.703644 2613.297363,131.607178 2612.062988,132.970001 
	C2603.581299,142.333908 2595.205811,151.793930 2586.816650,161.200058 
	C2584.418213,159.983643 2582.403076,158.961792 2580.390869,157.941254 
	C2578.833984,161.090775 2587.581543,172.595764 2597.127930,180.282028 
	C2598.400391,179.131226 2599.715820,177.941742 2601.057861,176.728043 
	C2599.812012,174.227066 2598.714600,172.024124 2597.528809,169.643677 
	C2603.215820,164.542725 2608.727295,159.599121 2614.724365,154.220047 
	C2614.724365,165.304962 2614.583008,175.575668 2614.820068,185.837662 
	C2614.881836,188.509979 2615.710449,191.361115 2616.910400,193.769516 
	C2619.396240,198.758545 2622.367920,203.505722 2625.263672,208.569092 
	C2600.346436,221.995224 2575.903076,235.165970 2551.459717,248.336716 
	C2551.210449,247.983536 2550.961182,247.630341 2550.712158,247.277161 
	C2565.445557,225.944550 2580.178955,204.611954 2595.116455,182.983963 
	C2588.868164,175.980347 2582.751709,169.124298 2576.493896,162.110077 
	C2553.692139,196.351700 2531.230469,230.194107 2508.569092,263.901978 
	C2506.739746,266.622528 2503.865967,269.086121 2500.920166,270.542206 
	C2467.937744,286.846893 2434.865479,302.970520 2401.751709,319.007263 
	C2398.606445,320.530579 2396.789551,322.151611 2396.671875,325.922729 
	C2396.534180,330.337524 2395.607178,334.727722 2394.897217,340.073029 
	C2363.431152,301.732666 2349.373291,257.960510 2346.885986,208.694199 
	C2331.006348,236.339142 2318.676270,263.613922 2315.717285,294.345520 
	C2312.679688,325.899323 2321.088379,353.913940 2340.817139,378.690582 
	C2359.375732,401.997894 2383.350830,418.378815 2409.321777,432.004700 
	C2446.988281,451.766663 2487.288818,464.490692 2528.179932,475.651062 
	C2583.629395,490.784760 2639.744873,500.001892 2697.444580,496.097382 
	C2712.174316,495.100647 2726.860107,493.454559 2741.951660,492.071503 
	C2740.224365,483.578400 2738.669434,475.931610 2737.101807,468.222473 
	C2735.630615,468.083038 2734.484863,467.971802 2733.338867,467.866241 
	C2714.438477,466.125763 2695.438965,465.099335 2676.659180,462.490814 
	C2642.323975,457.721619 2608.585693,449.937744 2575.393066,439.881683 
	C2541.567139,429.633942 2508.374268,417.730072 2476.480225,402.367462 
	C2473.418457,400.892670 2472.457764,399.275909 2472.779785,395.901306 
	C2473.777100,385.458221 2474.252441,374.964813 2475.285645,364.526093 
	C2475.454102,362.825989 2477.069580,360.677216 2478.619629,359.791534 
	C2532.373779,329.074402 2586.221436,298.520905 2639.967529,267.789795 
	C2643.402344,265.825867 2645.194092,266.288422 2647.883789,268.987976 
	C2691.755371,313.017578 2735.766357,356.908264 2779.667725,400.908417 
	C2782.059570,403.305878 2783.978516,404.070435 2787.392334,402.821533 
	C2804.715576,396.484131 2822.163086,390.487640 2839.554688,384.337097 
	C2847.194092,381.635406 2856.214844,380.917206 2858.457764,369.717316 
	C2860.475342,372.549164 2861.683594,374.245117 2863.010986,376.108459 
	C2866.315918,374.961761 2869.463135,373.869720 2873.046143,372.626587 
	C2871.105469,370.507538 2869.763916,368.793365 2868.171875,367.356567 
	C2864.995605,364.489777 2864.158447,361.513855 2865.794922,357.251099 
	C2867.195312,353.604218 2867.760986,349.481323 2867.902832,345.540436 
	C2868.163574,338.277954 2863.616455,334.296753 2856.438965,335.365631 
	C2852.183594,335.999329 2848.050049,337.415649 2843.821289,338.283936 
	C2842.521484,338.550873 2840.601562,338.718018 2839.791504,337.999695 
	C2831.840332,330.949860 2824.063965,323.703125 2816.238037,316.512268 
	C2815.641602,313.423309 2822.470947,310.664429 2815.828613,307.293030 
	C2814.633545,308.897369 2813.362061,310.604126 2812.230469,312.123199 
	C2805.503906,309.414612 2816.141846,303.784607 2809.572754,301.077545 
	C2804.958496,306.444794 2800.315918,311.667664 2795.942383,317.106628 
	C2795.213135,318.013367 2795.654297,319.861084 2795.495117,322.118774 
	C2797.707520,321.030243 2798.554932,320.428101 2799.494385,320.194855 
	C2800.875977,319.851746 2802.323242,319.771881 2803.742432,319.579926 
	C2803.422119,320.830780 2802.952637,322.066040 2802.819824,323.336487 
	C2802.658936,324.878357 2802.781738,326.449890 2802.781738,329.437592 
	C2807.776123,324.137939 2810.763428,325.989044 2813.580322,329.587158 
	C2815.007324,331.409546 2816.690186,333.031464 2817.876953,335.136536 
	C2817.757568,335.274200 2817.638428,335.411835 2816.716797,335.428070 
	C2808.363770,333.327698 2805.240967,339.840881 2801.222900,345.329987 
	C2788.191895,327.840881 2775.400391,310.673157 2762.608887,293.505402 
	C2762.959717,293.210480 2763.310547,292.915558 2763.661133,292.620605 
	C2773.050293,300.715271 2782.439453,308.809906 2792.078125,317.119812 
	C2798.503906,310.054474 2804.631348,303.316833 2810.822754,296.509247 
	C2809.223877,295.027527 2807.776611,293.655029 2806.296387,292.319092 
	C2771.447266,260.870575 2736.583496,229.437744 2701.768799,197.951187 
	C2699.693848,196.074387 2697.812012,193.911652 2696.164795,191.646011 
	C2685.802734,177.395279 2675.533203,163.077667 2665.013428,148.138641 
	C2662.887939,145.226425 2660.762695,142.314224 2658.356934,138.811325 
	C2657.039551,137.357086 2655.722168,135.902847 2653.696045,134.133743 
M2673.806885,70.686363 
	C2688.959717,73.804291 2704.233887,76.429314 2719.242432,80.132118 
	C2765.001953,91.421623 2809.338135,106.592987 2850.192383,130.620987 
	C2877.942383,146.941788 2903.383545,166.034317 2923.095947,191.998795 
	C2946.425293,222.727676 2957.469727,257.029907 2954.117188,295.689026 
	C2953.843018,298.854126 2953.525879,302.015533 2953.156006,305.952362 
	C2954.084717,304.782837 2954.545410,304.319244 2954.871338,303.774872 
	C2966.385498,284.552704 2975.741943,264.347931 2982.124512,242.846252 
	C2988.694092,220.715363 2991.376953,198.223465 2987.559082,175.237457 
	C2981.934082,141.370117 2963.519043,115.426071 2937.068359,94.696762 
	C2901.382812,66.730026 2859.677490,52.308105 2816.263428,41.998772 
	C2772.656738,31.643770 2728.279297,27.362524 2683.586914,26.185497 
	C2649.922363,25.298906 2616.317139,26.642836 2582.763184,29.802584 
	C2535.065430,34.294254 2488.052979,42.302738 2442.207031,56.381580 
	C2427.041748,61.038738 2412.156982,66.609093 2397.143799,71.761887 
	C2397.272217,72.195229 2397.400635,72.628563 2397.529297,73.061905 
	C2398.833984,72.951523 2400.173584,72.995323 2401.438232,72.708321 
	C2439.577637,64.052711 2478.275879,60.222401 2517.301758,58.973362 
	C2569.608398,57.299274 2621.458496,61.541039 2673.806885,70.686363 
M3088.725586,530.204346 
	C3090.659912,522.631592 3093.027100,515.138977 3094.447266,507.471008 
	C3098.755615,484.203705 3099.116699,461.062195 3089.739746,438.750763 
	C3077.985352,410.782410 3055.856934,393.266235 3029.569580,380.167114 
	C3028.199219,379.484283 3026.006104,379.730927 3024.441650,380.264496 
	C2971.091553,398.456512 2917.769287,416.730072 2864.448242,435.006500 
	C2852.430908,439.125610 2840.431396,443.297668 2827.815918,447.655304 
	C2829.524414,449.033478 2830.684814,449.910370 2831.780029,450.862152 
	C2841.446777,459.262695 2851.652344,467.128754 2860.663818,476.182709 
	C2897.096191,512.785889 2904.832764,555.364319 2883.953369,601.942688 
	C2881.265625,607.939148 2877.916016,613.638977 2874.524414,620.144714 
	C2876.720947,619.513672 2878.285889,619.137390 2879.801758,618.617798 
	C2941.460693,597.485107 3003.105225,576.310120 3064.776611,555.214111 
	C3082.823730,549.040771 3082.858154,549.141541 3088.725586,530.204346 
M2364.806885,627.500000 
	C2364.807617,646.491699 2364.781006,665.483398 2364.825928,684.474976 
	C2364.839844,690.374329 2365.601318,691.057556 2371.464844,691.082520 
	C2376.629150,691.104431 2381.808594,690.843689 2386.953857,691.157593 
	C2391.891113,691.458740 2393.247803,689.341187 2393.224609,684.683655 
	C2393.079346,655.530640 2393.148926,626.376465 2393.147461,597.222717 
	C2393.147461,596.045959 2393.147461,594.869263 2393.147461,593.692505 
	C2394.383545,594.732483 2394.782227,595.762207 2395.016846,596.828186 
	C2401.159424,624.750305 2407.211670,652.692383 2413.447266,680.593567 
	C2416.133057,692.610901 2415.054688,691.019653 2426.677246,691.079712 
	C2434.114990,691.117981 2434.408203,690.890686 2435.972656,683.747375 
	C2441.698242,657.603699 2447.384277,631.451416 2453.116455,605.309204 
	C2453.971191,601.412292 2454.994629,597.552368 2455.939941,593.675293 
	C2456.221924,593.749146 2456.503662,593.822937 2456.785400,593.896790 
	C2456.785400,606.383118 2456.785156,618.869446 2456.785156,631.355774 
	C2456.785156,648.514832 2456.782715,665.673950 2456.786133,682.833008 
	C2456.787842,690.902527 2456.964111,691.081299 2464.758301,691.086975 
	C2469.589600,691.090454 2474.434326,690.861267 2479.248047,691.152100 
	C2483.940430,691.435547 2485.260254,689.430603 2485.251465,684.974976 
	C2485.146729,632.831543 2485.132324,580.687805 2485.265625,528.544495 
	C2485.278320,523.553650 2483.078369,522.099792 2478.665039,522.144348 
	C2471.002441,522.221680 2463.336914,522.272522 2455.676270,522.128784 
	C2450.894287,522.039062 2448.573242,523.969543 2447.534180,528.827576 
	C2442.527832,552.230835 2437.195312,575.564331 2431.970947,598.920776 
	C2429.893066,608.208374 2427.794922,617.491455 2425.706055,626.776550 
	C2424.375244,625.713013 2424.089111,624.679260 2423.856445,623.633606 
	C2416.856934,592.160278 2409.804199,560.698486 2402.926758,529.198486 
	C2401.818115,524.120789 2399.402344,521.837585 2394.042236,522.083740 
	C2386.893555,522.411987 2379.718750,522.130920 2372.555420,522.174744 
	C2365.779785,522.216187 2364.813965,523.207458 2364.811523,530.042664 
	C2364.801270,562.195129 2364.806885,594.347534 2364.806885,627.500000 
M1384.623047,603.855164 
	C1379.837402,581.074280 1375.104614,558.282104 1370.247070,535.516541 
	C1367.115723,520.841797 1369.591309,522.161682 1352.143066,522.166504 
	C1348.219849,522.167603 1346.095703,524.027466 1345.288452,527.939880 
	C1340.956299,548.939636 1336.504395,569.914673 1332.087891,590.896973 
	C1329.917603,601.207458 1327.734253,611.515137 1325.556885,621.824097 
	C1323.671509,613.631653 1322.833984,605.494873 1322.161987,597.344482 
	C1320.247803,574.130310 1318.385864,550.911865 1316.544189,527.691772 
	C1316.276733,524.317566 1314.569824,522.337585 1311.240845,522.259644 
	C1304.913574,522.111572 1298.576904,522.087463 1292.250977,522.261353 
	C1288.633545,522.360718 1286.852173,524.381592 1287.321045,528.188965 
	C1288.031616,533.960083 1288.639160,539.744019 1289.273804,545.524292 
	C1292.105713,571.310913 1294.977417,597.093323 1297.744995,622.886780 
	C1299.963013,643.558105 1302.132080,664.235535 1304.137085,684.928162 
	C1304.577881,689.476990 1306.356323,691.428772 1311.076904,691.164062 
	C1316.724365,690.847290 1322.420532,690.815735 1328.062988,691.174072 
	C1332.816040,691.476013 1334.969604,689.590820 1335.997070,685.042358 
	C1341.931519,658.770691 1348.043091,632.538940 1354.123047,606.300293 
	C1354.914185,602.885925 1355.868896,599.509399 1356.747925,596.115356 
	C1359.469238,604.416687 1361.346680,612.503235 1363.202881,620.594604 
	C1368.185181,642.313049 1373.184692,664.027527 1378.109009,685.759033 
	C1378.918091,689.329834 1380.579834,691.278564 1384.570435,691.144958 
	C1390.895142,690.933167 1397.235352,690.963806 1403.562378,691.135010 
	C1407.192261,691.233215 1408.701904,689.486816 1409.070679,686.170166 
	C1410.282593,675.266663 1411.508301,664.364624 1412.750610,653.464478 
	C1415.650024,628.023926 1418.586548,602.587646 1421.460938,577.144226 
	C1423.290283,560.949707 1425.000488,544.741699 1426.842651,528.548645 
	C1427.284912,524.660583 1425.976685,522.290771 1421.883667,522.221191 
	C1415.720825,522.116455 1409.552490,522.095886 1403.391235,522.243774 
	C1399.926270,522.326904 1398.165649,524.062866 1397.848755,527.862244 
	C1395.761597,552.890747 1393.469849,577.902161 1391.238037,602.918579 
	C1390.674194,609.240601 1390.085205,615.560425 1389.507812,621.881226 
	C1389.125366,621.905884 1388.742920,621.930542 1388.360474,621.955200 
	C1387.165161,616.199768 1385.969849,610.444397 1384.623047,603.855164 
M2793.709961,507.865295 
	C2793.850098,508.854340 2793.936279,509.854523 2794.138184,510.830780 
	C2800.384766,541.037598 2804.145264,571.570679 2806.075439,602.337646 
	C2806.917236,615.756653 2807.590820,629.186218 2808.364502,643.040771 
	C2824.374023,637.576538 2840.263672,632.209900 2856.086670,626.654114 
	C2857.475586,626.166382 2858.721924,624.614380 2859.536865,623.257812 
	C2864.675049,614.706909 2870.214111,606.337524 2874.602295,597.407715 
	C2883.215332,579.879578 2887.173096,561.295837 2884.384277,541.704895 
	C2880.812500,516.614319 2867.320312,496.912903 2849.773438,479.634491 
	C2827.240723,457.446838 2800.494873,441.337799 2772.584961,426.985535 
	C2771.846924,426.605927 2770.971680,426.493530 2769.438477,426.045654 
	C2780.006104,452.867157 2787.661865,479.692017 2793.709961,507.865295 
M2128.555908,546.881714 
	C2126.111816,540.158630 2123.534912,533.479553 2121.281006,526.693237 
	C2120.209717,523.467285 2118.239258,522.141113 2115.015137,522.158569 
	C2109.849121,522.186584 2104.683350,522.146240 2099.517334,522.163452 
	C2092.571045,522.186584 2091.903076,522.870422 2091.902344,529.956543 
	C2091.898438,568.284668 2091.900635,606.612793 2091.900635,644.940918 
	C2091.900879,658.272400 2091.975830,671.604614 2091.858887,684.935059 
	C2091.821045,689.267090 2093.194824,691.422241 2097.941895,691.163574 
	C2103.591064,690.855713 2109.286133,690.825378 2114.930664,691.172363 
	C2119.710449,691.466248 2121.295166,689.852356 2121.259033,684.973145 
	C2121.058594,657.811707 2121.158936,630.647888 2121.168213,603.484924 
	C2121.168701,602.336487 2121.290771,601.187988 2121.356201,600.039551 
	C2122.822021,601.856567 2123.524902,603.701660 2124.189941,605.560303 
	C2133.832275,632.512390 2143.504150,659.454163 2153.062988,686.435852 
	C2154.218994,689.698730 2155.849121,691.390442 2159.553223,691.156616 
	C2164.034912,690.873657 2168.547852,691.091125 2173.047363,691.091064 
	C2182.713623,691.090820 2182.713867,691.090576 2182.713867,681.640564 
	C2182.714111,646.145386 2182.713867,610.650208 2182.713867,575.155029 
	C2182.713867,559.657166 2182.618896,544.158325 2182.770752,528.661926 
	C2182.817139,523.927124 2180.904053,521.974060 2176.235352,522.123413 
	C2171.074707,522.288452 2165.904785,522.147827 2160.738770,522.162659 
	C2153.675049,522.182983 2153.312256,522.535889 2153.311035,529.427124 
	C2153.306152,555.590210 2153.309082,581.753357 2153.308838,607.916443 
	C2153.308838,609.634888 2153.308838,611.353333 2153.308838,613.071777 
	C2152.933838,613.128967 2152.558838,613.186157 2152.184082,613.243347 
	C2144.394775,591.368225 2136.605713,569.493103 2128.555908,546.881714 
M1813.310425,575.174255 
	C1807.673340,559.341797 1801.912598,543.551636 1796.481445,527.648804 
	C1795.029175,523.396362 1792.584839,521.912170 1788.336792,522.116516 
	C1783.847900,522.332397 1779.340454,522.156921 1774.841187,522.166260 
	C1767.288574,522.181885 1766.809814,522.642883 1766.808838,529.974609 
	C1766.804932,560.136780 1766.806885,590.298889 1766.807129,620.461060 
	C1766.807251,641.957825 1766.869873,663.454895 1766.756714,684.951111 
	C1766.733765,689.320984 1768.065186,691.420715 1772.807129,691.160217 
	C1778.455811,690.849976 1784.150757,690.824402 1789.795654,691.167908 
	C1794.567993,691.458252 1796.190552,689.873962 1796.153687,684.965881 
	C1795.950928,657.971436 1796.056763,630.974731 1796.056641,603.978760 
	C1796.056641,602.618225 1796.056396,601.257690 1796.056396,599.897156 
	C1797.398071,601.216064 1797.986572,602.541626 1798.473755,603.903381 
	C1808.229126,631.165710 1818.036255,658.410034 1827.647217,685.723267 
	C1829.005981,689.584656 1830.806885,691.501038 1835.143188,691.170471 
	C1839.947876,690.804199 1844.802124,691.088867 1849.634766,691.087158 
	C1857.339478,691.084412 1857.527344,690.919739 1857.529419,683.350891 
	C1857.537964,651.355713 1857.533447,619.360474 1857.533203,587.365295 
	C1857.533081,567.868225 1857.561035,548.371094 1857.513916,528.874146 
	C1857.500000,523.119751 1856.544556,522.231323 1850.775024,522.176575 
	C1845.442993,522.125977 1840.109741,522.128845 1834.777710,522.174927 
	C1828.734985,522.227112 1828.139771,522.821289 1828.137451,528.722107 
	C1828.126953,555.051514 1828.132324,581.380859 1828.132202,607.710266 
	C1828.132080,609.559143 1828.132324,611.408081 1828.132324,613.256958 
	C1827.774170,613.277466 1827.416138,613.297913 1827.057983,613.318420 
	C1822.575195,600.844543 1818.092529,588.370667 1813.310425,575.174255 
M2575.573730,688.277771 
	C2584.337646,684.440735 2589.308350,677.396057 2589.929932,668.226685 
	C2590.840088,654.798340 2590.450928,641.287231 2590.960693,627.824463 
	C2591.307617,618.658508 2589.592285,610.854797 2579.220703,606.902832 
	C2586.144775,603.677124 2590.672852,599.309509 2590.796631,592.329163 
	C2591.048096,578.177979 2591.300293,563.997192 2590.672363,549.867798 
	C2589.939453,533.381836 2581.275391,523.929138 2565.002197,522.969421 
	C2546.912354,521.902771 2528.731445,522.373840 2510.590088,522.197571 
	C2506.581299,522.158630 2505.718994,524.564270 2505.722900,528.102844 
	C2505.780762,580.399902 2505.791504,632.697083 2505.711426,684.994080 
	C2505.704590,689.397827 2507.083496,691.236267 2511.778809,691.172791 
	C2528.097900,690.952393 2544.424805,691.266479 2560.741699,690.972717 
	C2565.468262,690.887634 2570.170654,689.446106 2575.573730,688.277771 
M1085.621582,691.087769 
	C1101.774658,691.085022 1117.927979,691.139709 1134.080688,691.062561 
	C1148.780396,690.992371 1159.615356,682.784912 1160.910889,668.281067 
	C1162.341797,652.261841 1161.857422,636.048889 1161.707764,619.924988 
	C1161.663208,615.121765 1158.652344,611.214355 1154.257202,608.748657 
	C1153.189331,608.149536 1152.170288,607.463074 1150.775757,606.597656 
	C1157.590454,603.639771 1161.829956,599.079712 1161.943481,592.024963 
	C1162.168335,578.041138 1162.327026,564.038513 1161.855591,550.065857 
	C1161.306519,533.788574 1152.454590,523.955994 1136.361206,522.985962 
	C1119.105713,521.945740 1101.761841,522.341064 1084.455933,522.181213 
	C1077.383789,522.115906 1076.853027,522.728516 1076.852661,529.881226 
	C1076.849487,581.004761 1076.849365,632.128235 1076.852539,683.251770 
	C1076.853027,690.923462 1077.010742,691.071472 1085.621582,691.087769 
M922.664307,690.177063 
	C931.246948,690.447815 939.829651,690.813782 948.411865,690.800354 
	C949.066101,690.799316 950.430847,688.004700 950.234009,686.693420 
	C949.644165,682.762756 948.486084,678.912598 947.473572,675.051025 
	C943.739197,660.808716 939.973999,646.574524 936.221802,632.342224 
	C946.647400,627.083740 950.871094,618.448425 951.057251,607.719360 
	C951.369324,589.735474 951.795349,571.733582 951.271179,553.765625 
	C951.079224,547.185974 949.515259,540.050537 946.470520,534.280212 
	C940.987671,523.889160 930.235046,522.394470 919.661621,522.229797 
	C903.837524,521.983337 888.006897,522.155945 872.179016,522.164734 
	C864.786865,522.168823 864.117737,522.825500 864.117188,530.033813 
	C864.113342,577.517395 864.115051,625.001038 864.115173,672.484619 
	C864.115173,676.816467 864.157288,681.148743 864.105835,685.479980 
	C864.060120,689.323853 865.485474,691.318542 869.730225,691.150635 
	C875.885132,690.907166 882.065918,690.884521 888.218262,691.158936 
	C892.558105,691.352539 893.678589,689.382263 893.619263,685.478821 
	C893.474854,675.984314 893.572815,666.486084 893.573059,656.989380 
	C893.573181,649.868713 893.573120,642.748047 893.573120,635.088867 
	C896.742188,635.088867 899.402283,635.369202 901.979187,635.025818 
	C906.298584,634.450378 907.927612,636.228394 908.976562,640.382568 
	C913.127136,656.821045 917.708435,673.150818 922.664307,690.177063 
M1028.957642,522.406311 
	C1011.630737,522.327759 994.303772,522.253540 976.976868,522.167236 
	C973.242554,522.148621 971.687073,523.861328 971.692078,527.697388 
	C971.761230,580.357300 971.763184,633.017334 971.694336,685.677185 
	C971.689026,689.735535 973.119385,691.209229 977.279785,691.164917 
	C994.609009,690.980286 1011.941650,691.157471 1029.272217,691.056152 
	C1043.015259,690.975769 1052.615967,683.181030 1055.579224,669.768066 
	C1056.256714,666.701294 1056.689697,663.510742 1056.696289,660.376038 
	C1056.771240,624.714172 1057.029907,589.048767 1056.625977,553.391296 
	C1056.402100,533.622864 1047.982056,524.581787 1028.957642,522.406311 
M1552.142822,632.500000 
	C1552.401855,644.147278 1552.221680,655.825378 1553.038818,667.433411 
	C1553.917725,679.919861 1561.441772,688.832214 1573.852295,690.002991 
	C1588.371338,691.372620 1603.187744,691.800903 1617.689087,690.524048 
	C1632.390137,689.229675 1640.237061,680.105103 1640.838501,665.083435 
	C1641.664429,644.457336 1641.315063,623.784241 1641.469604,603.131287 
	C1641.491943,600.147034 1640.207153,598.358948 1637.037842,598.356201 
	C1625.707886,598.346191 1614.377808,598.353210 1603.047852,598.344360 
	C1600.219360,598.342163 1598.688965,599.633362 1598.691040,602.556763 
	C1598.695923,609.220276 1598.682983,615.883850 1598.683350,622.547363 
	C1598.683594,625.634705 1600.190430,627.113831 1603.322998,627.037109 
	C1606.423950,626.961121 1609.528198,627.020508 1612.895630,627.020508 
	C1612.895630,636.797363 1613.052124,645.939392 1612.829834,655.072266 
	C1612.718018,659.667786 1610.171997,662.520020 1605.278198,662.630920 
	C1601.115723,662.725159 1596.950806,662.800598 1592.787842,662.766602 
	C1583.508789,662.690918 1581.634521,660.824524 1581.626221,651.641602 
	C1581.606079,629.481201 1581.619507,607.320740 1581.620483,585.160339 
	C1581.620972,576.829346 1581.515381,568.496521 1581.660278,560.168030 
	C1581.782104,553.161621 1584.015625,550.998779 1591.074341,550.785461 
	C1595.402222,550.654663 1599.743652,550.629761 1604.068237,550.811096 
	C1610.292480,551.071960 1612.758789,553.647095 1612.894287,559.856934 
	C1612.992554,564.353516 1613.058838,568.860046 1612.871704,573.350891 
	C1612.707764,577.286438 1614.482300,578.741211 1618.243530,578.669250 
	C1624.239624,578.554382 1630.240845,578.559265 1636.237305,578.665833 
	C1639.812256,578.729309 1641.527222,577.140320 1641.451782,573.604980 
	C1641.256470,564.451050 1641.527466,555.254578 1640.721191,546.153992 
	C1639.557861,533.022034 1630.543823,523.822449 1617.297363,523.078308 
	C1603.543213,522.305603 1589.690186,522.429871 1575.921143,523.057068 
	C1564.598877,523.572876 1556.351685,531.153015 1553.839355,542.214050 
	C1552.781372,546.871216 1552.245728,551.742798 1552.215942,556.521545 
	C1552.060059,581.513611 1552.142944,606.507019 1552.142822,632.500000 
M2330.922119,687.576416 
	C2339.066895,683.118652 2343.584717,675.957886 2343.854980,666.984192 
	C2344.496338,645.689087 2344.449707,624.373291 2344.671631,603.065674 
	C2344.706543,599.708496 2342.926270,598.311340 2339.661621,598.323608 
	C2328.667236,598.364868 2317.673096,598.362793 2306.678711,598.323975 
	C2303.425049,598.312500 2301.767822,599.544800 2301.849609,603.061401 
	C2301.996826,609.388000 2301.995361,615.723022 2301.849609,622.049744 
	C2301.764404,625.747314 2303.418213,627.180786 2306.961670,627.048401 
	C2309.890137,626.938965 2312.825684,627.026001 2315.973389,627.026001 
	C2315.973389,636.824036 2316.097900,645.967957 2315.921387,655.106079 
	C2315.831299,659.766174 2313.320312,662.542725 2308.409180,662.628601 
	C2304.246826,662.701416 2300.083740,662.795593 2295.921631,662.764893 
	C2286.648193,662.696472 2284.818848,660.852234 2284.812744,651.618774 
	C2284.798828,630.462952 2284.808105,609.307129 2284.808594,588.151306 
	C2284.808838,578.822754 2284.723877,569.493103 2284.842041,560.166016 
	C2284.927490,553.421875 2287.221924,551.040100 2293.786865,550.804016 
	C2298.444336,550.636536 2303.122803,550.612183 2307.774658,550.854858 
	C2313.431396,551.149841 2315.816162,553.709656 2315.977295,559.422302 
	C2316.113525,564.249390 2316.065918,569.083984 2315.996582,573.913757 
	C2315.952148,577.003235 2317.314453,578.618835 2320.431152,578.626038 
	C2326.927734,578.641052 2333.424316,578.622925 2339.920898,578.637024 
	C2342.960449,578.643616 2344.701172,577.198425 2344.638672,574.122742 
	C2344.443115,564.475220 2344.768799,554.762756 2343.736816,545.200195 
	C2342.388916,532.707520 2333.500000,523.817688 2321.016602,523.101318 
	C2306.935547,522.293274 2292.729248,522.255798 2278.658203,523.150696 
	C2268.033447,523.826416 2260.367188,530.105103 2257.262451,540.663208 
	C2256.058594,544.758057 2255.405518,549.166016 2255.388428,553.434875 
	C2255.245605,589.082642 2254.974609,624.735596 2255.436279,660.377930 
	C2255.715088,681.914001 2265.823242,691.087708 2287.277832,691.093384 
	C2296.606445,691.095886 2305.953369,691.443054 2315.255859,690.949402 
	C2320.294434,690.681946 2325.256592,688.975342 2330.922119,687.576416 
M1958.019409,529.443115 
	C1952.732422,527.253906 1947.553711,523.566040 1942.136841,523.174866 
	C1929.242432,522.243713 1916.216064,522.422485 1903.279297,522.986206 
	C1888.250122,523.641052 1878.546753,533.163940 1878.253174,548.083313 
	C1877.643677,579.044373 1877.685669,610.019043 1877.567383,640.988525 
	C1877.536865,648.972900 1877.626831,656.977051 1878.150146,664.940002 
	C1879.239136,681.508972 1889.510498,690.988464 1906.118286,691.074646 
	C1917.277710,691.132507 1928.438721,691.176819 1939.597168,691.055908 
	C1954.206177,690.897644 1965.247559,681.656921 1965.933472,667.111938 
	C1966.944092,645.679016 1966.623657,624.182861 1966.834961,602.713318 
	C1966.866211,599.528687 1964.917847,598.345398 1961.978638,598.346741 
	C1950.818970,598.351685 1939.659302,598.361511 1928.499634,598.342346 
	C1925.373657,598.336975 1924.022339,599.769165 1924.079956,602.946411 
	C1924.197632,609.440308 1924.194214,615.938965 1924.086304,622.433105 
	C1924.033081,625.636658 1925.492676,627.025391 1928.566284,627.016602 
	C1931.671875,627.007690 1934.777344,627.014648 1938.133423,627.014648 
	C1938.133423,636.956665 1938.260010,646.263672 1938.076416,655.564575 
	C1937.992920,659.787781 1935.607788,662.414673 1931.188110,662.584229 
	C1926.864380,662.750244 1922.532959,662.778198 1918.205200,662.770996 
	C1909.023193,662.755676 1906.984497,660.746948 1906.978027,651.684021 
	C1906.960449,627.032715 1906.971436,602.381348 1906.972412,577.730042 
	C1906.972778,571.733826 1906.843994,565.733582 1907.020020,559.742432 
	C1907.205811,553.419434 1909.626587,551.019409 1915.902222,550.797058 
	C1920.393555,550.637817 1924.901001,550.627014 1929.390991,550.806396 
	C1935.730469,551.059631 1938.052490,553.492188 1938.168701,559.781494 
	C1938.254883,564.443726 1938.258545,569.110046 1938.170532,573.772095 
	C1938.107056,577.128235 1939.599731,578.674683 1942.957764,578.645325 
	C1949.120117,578.591431 1955.284302,578.566528 1961.445801,578.655090 
	C1965.197632,578.708984 1966.954468,577.119507 1966.894165,573.277649 
	C1966.781982,566.117188 1967.115967,558.940369 1966.759888,551.795532 
	C1966.357544,543.721069 1964.838379,535.887512 1958.019409,529.443115 
M507.607147,628.559937 
	C507.607147,626.270691 507.607147,623.981506 507.607147,621.517944 
	C516.689026,621.517944 525.221924,621.517944 533.937073,621.517944 
	C533.937073,623.718506 533.937073,625.545105 533.937073,627.371704 
	C533.937256,646.696777 534.029419,666.022644 533.867188,685.346313 
	C533.830688,689.689819 535.310852,691.344666 539.676453,691.155212 
	C545.662598,690.895325 551.677124,690.893799 557.663025,691.156982 
	C561.877441,691.342224 563.234497,689.572327 563.229980,685.584961 
	C563.171570,632.940857 563.169067,580.296692 563.237915,527.652588 
	C563.242981,523.759399 561.528320,522.171143 557.872986,522.169312 
	C552.042175,522.166443 546.210815,522.114502 540.380615,522.174622 
	C534.591309,522.234314 533.943848,522.944458 533.940918,528.930054 
	C533.931335,548.255127 533.937195,567.580200 533.937134,586.905273 
	C533.937134,588.693542 533.937134,590.481812 533.937134,592.500671 
	C525.051941,592.500671 516.646301,592.500671 507.607239,592.500671 
	C507.607239,590.462524 507.607269,588.685303 507.607239,586.908081 
	C507.607117,567.749573 507.612061,548.591125 507.604034,529.432617 
	C507.601257,522.814819 507.010193,522.201050 500.579865,522.165344 
	C495.582153,522.137634 490.584045,522.138733 485.586334,522.164978 
	C478.916260,522.199951 478.142883,522.970642 478.141693,529.638000 
	C478.134552,569.954102 478.137787,610.270142 478.138123,650.586243 
	C478.138214,662.247925 478.191376,673.909973 478.112579,685.571106 
	C478.086029,689.501221 479.492188,691.348022 483.723022,691.158325 
	C489.708435,690.890015 495.730591,690.823425 501.707306,691.175537 
	C506.502594,691.458069 507.705017,689.400085 507.669800,685.019104 
	C507.521210,666.528198 507.606750,648.035400 507.607147,628.559937 
M192.034454,539.505615 
	C192.034286,535.674194 191.837067,531.829956 192.085388,528.014709 
	C192.375137,523.562927 190.268997,522.050232 186.147324,522.135437 
	C180.818970,522.245667 175.486450,522.139526 170.155930,522.165039 
	C163.285172,522.197937 162.762115,522.720032 162.761383,529.558228 
	C162.756104,578.700317 162.758484,627.842346 162.758545,676.984436 
	C162.758545,679.649780 162.905945,682.325012 162.726822,684.978210 
	C162.433578,689.322083 163.854935,691.456665 168.662384,691.172119 
	C174.472443,690.828247 180.332367,690.842224 186.144440,691.168884 
	C190.859421,691.433838 192.152420,689.530884 192.111160,685.051392 
	C191.931702,665.562805 192.034302,646.071594 192.034424,626.581360 
	C192.034439,624.833435 192.034424,623.085571 192.034424,621.531738 
	C201.194992,621.531738 209.595245,621.531738 218.295654,621.531738 
	C218.295654,623.571777 218.295654,625.224548 218.295654,626.877319 
	C218.295654,646.200989 218.396378,665.525574 218.224136,684.847717 
	C218.181595,689.617676 219.807648,691.501160 224.651627,691.163879 
	C229.459244,690.829163 234.308365,691.091614 239.139282,691.091064 
	C247.780136,691.090027 247.782745,691.089661 247.783295,682.655457 
	C247.784760,659.666931 247.783859,636.678467 247.783829,613.689941 
	C247.783798,585.537354 247.792389,557.384766 247.776794,529.232178 
	C247.773422,523.148132 246.878143,522.230591 240.915817,522.172180 
	C235.585648,522.119934 230.254028,522.111755 224.924072,522.173889 
	C219.089752,522.241882 218.308594,523.039734 218.302765,528.846497 
	C218.284683,546.837463 218.295792,564.828491 218.295563,582.819458 
	C218.295532,585.945312 218.295563,589.071167 218.295563,592.478516 
	C209.367950,592.478516 200.964096,592.478516 192.034470,592.478516 
	C192.034470,575.049561 192.034470,557.776428 192.034454,539.505615 
M2696.117676,662.500000 
	C2696.117676,618.009888 2696.121826,573.519836 2696.112061,529.029724 
	C2696.110840,523.231567 2695.207520,522.258911 2689.575684,522.183777 
	C2683.911377,522.108154 2678.243652,522.245544 2672.580322,522.144653 
	C2668.383545,522.069946 2666.753418,523.754517 2666.795166,528.137268 
	C2666.982178,547.797668 2666.875732,567.460999 2666.875244,587.123230 
	C2666.875244,588.884277 2666.875488,590.645325 2666.875488,592.320007 
	C2657.637207,592.320007 2649.097168,592.320007 2640.264404,592.320007 
	C2640.264404,590.050537 2640.264404,588.231934 2640.264404,586.413269 
	C2640.264404,567.250916 2640.270264,548.088562 2640.260254,528.926208 
	C2640.256836,522.722046 2639.718750,522.201721 2633.350830,522.169922 
	C2628.851807,522.147461 2624.352783,522.162659 2619.853760,522.165894 
	C2611.414307,522.171936 2611.006592,522.564880 2611.006348,530.759033 
	C2611.004639,581.414307 2611.005615,632.069641 2611.005859,682.724915 
	C2611.005859,683.558044 2611.050293,684.393799 2611.000977,685.223938 
	C2610.758057,689.318604 2612.235107,691.392273 2616.770020,691.158813 
	C2622.586670,690.859375 2628.444336,690.837952 2634.258057,691.166138 
	C2638.834229,691.424500 2640.397949,689.863525 2640.349609,685.215149 
	C2640.146484,665.721680 2640.264404,646.224792 2640.264648,626.729187 
	C2640.264648,624.966492 2640.264404,623.203796 2640.264404,621.538574 
	C2649.560547,621.538574 2658.120605,621.538574 2666.875488,621.538574 
	C2666.875488,623.764099 2666.875488,625.589661 2666.875488,627.415222 
	C2666.875488,646.744202 2666.973145,666.074036 2666.801270,685.401489 
	C2666.762207,689.799133 2668.313721,691.343201 2672.641357,691.152527 
	C2678.628174,690.888733 2684.644287,690.889343 2690.631348,691.152283 
	C2694.914307,691.340271 2696.211182,689.399963 2696.149170,685.494507 
	C2696.032715,678.164734 2696.117188,670.831665 2696.117676,662.500000 
M267.864197,659.423157 
	C268.013397,661.413452 268.113739,663.408875 268.319611,665.393311 
	C269.877960,680.415894 277.055725,689.038391 291.882263,690.562500 
	C304.069397,691.815247 316.512207,691.437805 328.781250,690.731934 
	C336.766937,690.272522 344.676971,686.876343 348.004059,679.142700 
	C350.871674,672.477112 352.634674,664.820801 352.740662,657.571106 
	C353.225037,624.445007 352.986938,591.307861 352.914642,558.174805 
	C352.904846,553.698425 352.625946,549.187134 352.017548,544.754333 
	C350.386780,532.872559 341.270660,523.657043 329.375610,523.056396 
	C316.789093,522.420776 304.110077,522.338257 291.537628,523.102478 
	C281.329651,523.723083 273.471893,529.309143 270.260162,539.343628 
	C268.569458,544.626038 267.994263,550.457520 267.961548,556.047241 
	C267.761749,590.178162 267.862122,624.310913 267.864197,659.423157 
M1691.797363,658.291565 
	C1691.516846,655.826111 1690.994995,653.361023 1690.991943,650.895203 
	C1690.941040,610.738892 1690.958130,570.582581 1690.953735,530.426208 
	C1690.952881,523.178162 1689.940308,522.192139 1682.513672,522.163086 
	C1678.514648,522.147400 1674.515747,522.153015 1670.516724,522.162048 
	C1662.604980,522.179932 1661.520996,523.220764 1661.515503,531.044312 
	C1661.498535,554.871521 1661.431030,578.699036 1661.532471,602.525818 
	C1661.622681,623.675842 1661.626709,644.833069 1662.218750,665.971680 
	C1662.587036,679.117310 1670.343384,688.565063 1683.263916,689.988892 
	C1696.261475,691.421265 1709.522705,691.279480 1722.618774,690.701721 
	C1730.820923,690.339844 1738.701172,686.550903 1742.088501,678.617615 
	C1744.814697,672.232544 1746.365601,664.889343 1746.497803,657.934387 
	C1746.994995,631.783875 1746.697998,605.618286 1746.698242,579.458313 
	C1746.698364,562.962524 1746.720337,546.466736 1746.686646,529.971008 
	C1746.673950,523.749878 1745.178833,522.244385 1739.095703,522.170959 
	C1734.764038,522.118713 1730.431274,522.136353 1726.099121,522.165955 
	C1719.191406,522.213196 1718.067505,523.358337 1718.066650,530.333374 
	C1718.062012,570.323120 1718.065552,610.312805 1718.060913,650.302551 
	C1718.060791,651.967834 1718.116577,653.643127 1717.961426,655.296387 
	C1717.523926,659.955688 1715.084961,662.651611 1710.230713,662.695801 
	C1706.235229,662.732117 1702.180298,663.058228 1698.265381,662.482971 
	C1696.086304,662.162781 1694.139404,660.262451 1691.797363,658.291565 
M428.845856,648.379761 
	C428.848114,661.662598 427.671265,662.828125 414.300873,662.784241 
	C413.467987,662.781494 412.634094,662.802795 411.802368,662.770020 
	C404.964142,662.500732 402.567871,660.231934 402.275055,653.326904 
	C402.084686,648.837097 402.105194,644.328247 402.270721,639.836792 
	C402.392456,636.534058 401.234619,634.781006 397.766205,634.802490 
	C391.103302,634.843811 384.439941,634.825378 377.776794,634.816895 
	C374.776093,634.813049 372.926910,636.165405 373.017334,639.276855 
	C373.312042,649.415955 373.088440,659.624817 374.251831,669.669312 
	C375.539673,680.788025 383.301361,688.907654 394.523773,689.971313 
	C407.555756,691.206482 420.823486,691.657349 433.858917,690.692505 
	C448.024292,689.644104 456.324341,680.853943 457.179352,666.549866 
	C458.201202,649.454651 457.905640,632.278198 458.078339,615.135925 
	C458.157257,607.300415 456.539337,605.300171 449.098663,602.883606 
	C434.702972,598.208313 420.345673,593.412720 405.913361,588.853882 
	C403.000488,587.933899 402.047699,586.496033 402.167236,583.525391 
	C402.388092,578.037109 402.230469,572.533508 402.230469,567.036316 
	C402.230499,551.495056 403.861023,549.964905 419.568390,550.766113 
	C426.122772,551.100403 428.524963,553.382141 428.801910,560.007019 
	C428.996582,564.663330 428.955353,569.337341 428.813354,573.997253 
	C428.711670,577.332825 430.099030,579.058350 433.427094,579.066833 
	C440.088501,579.083740 446.750275,579.066772 453.411469,579.009827 
	C456.381287,578.984436 458.163116,577.558838 458.078186,574.426636 
	C457.812134,564.615662 458.050018,554.750061 457.063721,545.009827 
	C455.790680,532.438171 446.502197,523.672119 433.777496,523.027527 
	C422.015228,522.431702 410.182098,522.484436 398.411865,522.989807 
	C384.344757,523.593933 374.764587,532.472046 373.964844,546.490601 
	C372.989349,563.590088 373.190094,580.759338 372.995087,597.899719 
	C372.881134,607.913330 373.852539,609.050415 383.279755,612.138611 
	C398.434753,617.103333 413.567322,622.136414 428.845764,627.185608 
	C428.845764,634.101746 428.845764,640.756104 428.845856,648.379761 
M598.064392,610.565308 
	C596.486328,617.878723 594.902344,625.190918 593.331421,632.505859 
	C589.594666,649.904541 585.806335,667.292480 582.164062,684.710938 
	C580.970581,690.418640 581.577515,691.057800 586.887756,691.082642 
	C592.886841,691.110657 598.893799,690.906738 604.882690,691.154602 
	C608.712341,691.313110 610.628784,690.183411 611.260620,686.120728 
	C612.562927,677.748474 614.501160,669.476074 615.859192,661.110901 
	C616.313293,658.313599 617.485291,657.516113 620.090332,657.537781 
	C629.921692,657.619324 639.755005,657.638184 649.585754,657.525940 
	C652.432556,657.493408 653.612000,658.368408 654.098267,661.373108 
	C655.452271,669.739136 657.383667,678.010376 658.829102,686.363647 
	C659.416687,689.759033 660.821777,691.277893 664.406433,691.146729 
	C670.231201,690.933594 676.069458,691.093445 681.902039,691.088196 
	C688.513977,691.082214 689.200623,690.343445 687.814636,683.914062 
	C676.567200,631.737000 665.245972,579.575806 654.075867,527.382263 
	C653.240295,523.477844 651.269287,522.105957 647.559692,522.142029 
	C639.561523,522.219727 631.557495,522.325012 623.564758,522.100769 
	C618.954651,521.971436 616.782471,523.555603 615.787598,528.328918 
	C610.122803,555.506592 604.124451,582.614807 598.064392,610.565308 
M119.984016,522.167236 
	C115.674454,521.978088 113.420334,524.216125 111.982880,528.161255 
	C108.906746,536.603760 105.501190,544.926575 102.208908,553.289856 
	C99.629547,559.842224 97.017654,566.381775 94.072266,573.803833 
	C93.126396,571.824829 92.581635,570.841858 92.172455,569.805298 
	C86.795418,556.184509 81.202904,542.641602 76.195839,528.885681 
	C74.318436,523.727905 71.383698,521.812866 66.171432,522.108521 
	C61.686184,522.362976 57.175034,522.151978 52.675373,522.162781 
	C44.155121,522.183167 43.196239,523.661377 46.448803,531.523682 
	C55.994129,554.597351 65.615440,577.640808 74.904221,600.817505 
	C75.936729,603.393738 75.888008,607.091553 74.867287,609.690491 
	C68.358849,626.262085 61.439522,642.672363 54.650860,659.133850 
	C51.287876,667.288574 47.834023,675.407043 44.573498,683.602478 
	C42.173233,689.635620 43.205082,691.075562 49.527283,691.087646 
	C55.360188,691.098816 61.203941,690.871887 67.022507,691.160828 
	C71.361519,691.376282 73.656456,689.757874 75.204247,685.651489 
	C80.311295,672.102112 85.758934,658.681030 91.101936,645.221008 
	C91.845604,643.347534 92.735985,641.532410 93.943253,638.828430 
	C94.985275,641.177979 95.555084,642.355103 96.037514,643.566956 
	C101.700783,657.793152 107.248795,672.066956 113.122536,686.205566 
	C113.936775,688.165466 116.257622,690.729980 118.027023,690.849243 
	C125.658417,691.363892 133.344727,691.125671 141.009903,691.048279 
	C144.160736,691.016541 145.060608,689.165161 144.166183,686.327271 
	C143.667313,684.744446 143.082794,683.183472 142.448517,681.649109 
	C132.529221,657.654968 122.673973,633.633606 112.576889,609.714478 
	C111.134941,606.298645 111.361160,603.565491 112.734779,600.299255 
	C122.543129,576.976929 132.212906,553.596313 141.888596,530.218323 
	C144.528625,523.839600 143.399368,522.225098 136.390442,522.169739 
	C131.224457,522.128967 126.057892,522.162781 119.984016,522.167236 
M1447.990601,689.478516 
	C1449.461548,690.015503 1450.930542,691.014893 1452.403564,691.020569 
	C1477.386841,691.116699 1502.370972,691.040833 1527.354126,691.143188 
	C1530.989258,691.158081 1531.956665,689.558716 1531.883423,686.293152 
	C1531.752563,680.466553 1531.579102,674.618896 1531.929810,668.810608 
	C1532.210327,664.166077 1530.468384,662.659241 1525.943359,662.714294 
	C1511.121948,662.894836 1496.296875,662.781311 1481.473267,662.780884 
	C1479.721680,662.780884 1477.970093,662.780945 1476.177246,662.780945 
	C1476.177246,648.556580 1476.177246,635.131836 1476.177246,621.373352 
	C1478.067627,621.288940 1479.687866,621.156860 1481.308472,621.153870 
	C1492.134766,621.134216 1502.961914,621.057800 1513.786743,621.184875 
	C1517.809570,621.232117 1519.587646,619.622742 1519.505127,615.578796 
	C1519.383179,609.585144 1519.386597,603.585999 1519.491089,597.591858 
	C1519.558594,593.725830 1517.810791,592.329895 1514.021606,592.378357 
	C1503.197021,592.516785 1492.369751,592.439209 1481.543457,592.409485 
	C1479.794067,592.404663 1478.045166,592.209839 1475.905396,592.078979 
	C1475.905396,578.900146 1475.907715,566.271545 1475.903931,553.642944 
	C1475.902832,550.097961 1478.563232,550.894592 1480.561279,550.888672 
	C1495.384766,550.844604 1510.208496,550.867493 1525.032104,550.863708 
	C1531.837524,550.862000 1531.839722,550.856201 1531.845581,543.831665 
	C1531.849609,539.168030 1531.848267,534.504456 1531.845459,529.840820 
	C1531.841064,522.272278 1531.738525,522.162720 1523.900757,522.160583 
	C1501.082275,522.154480 1478.263916,522.154419 1455.445435,522.160706 
	C1447.769775,522.162842 1447.187500,522.741638 1447.187012,530.324890 
	C1447.184204,581.291626 1447.180664,632.258301 1447.205078,683.225037 
	C1447.205933,685.035156 1447.494995,686.845093 1447.990601,689.478516 
M836.247559,522.158447 
	C813.581482,522.158386 790.915405,522.157043 768.249329,522.158936 
	C759.490540,522.159668 759.158630,522.482849 759.158447,531.004639 
	C759.157349,577.003418 759.157715,623.002197 759.158081,669.000977 
	C759.158142,674.667480 759.141174,680.334167 759.170532,686.000488 
	C759.187866,689.345703 760.489563,691.156494 764.269287,691.141357 
	C789.268250,691.041260 814.268005,691.042847 839.266968,691.142456 
	C842.839417,691.156677 843.949219,689.684143 843.862000,686.351318 
	C843.718140,680.855225 843.827942,675.352661 843.821716,669.852783 
	C843.813904,662.875427 843.755798,662.794373 836.956787,662.786377 
	C822.457153,662.769226 807.957581,662.781006 793.457947,662.780945 
	C791.705750,662.780945 789.953552,662.780945 788.162109,662.780945 
	C788.162109,648.551025 788.162109,635.120972 788.162109,621.371521 
	C790.058899,621.287781 791.685791,621.156738 793.312988,621.153748 
	C803.812744,621.134705 814.312500,621.168213 824.812134,621.133789 
	C830.759338,621.114319 831.353333,620.526184 831.431885,614.510071 
	C831.501526,609.177795 831.289429,603.837769 831.495605,598.512573 
	C831.667480,594.073303 830.053040,592.242981 825.409363,592.347656 
	C814.581848,592.591797 803.741882,592.274719 792.913696,592.503784 
	C789.055481,592.585388 787.668274,591.560181 787.772949,587.501892 
	C788.043457,577.009155 788.064636,566.499084 787.766785,556.007812 
	C787.644836,551.712036 789.142273,550.721191 793.180298,550.778992 
	C808.176880,550.993713 823.180176,550.733337 838.176758,550.947815 
	C842.595703,551.011047 844.115295,549.484436 843.891907,545.147217 
	C843.609314,539.661926 843.504395,534.127197 843.914062,528.658020 
	C844.310974,523.359131 841.932861,521.723450 836.247559,522.158447 
M1266.333252,664.264954 
	C1264.318604,663.770325 1262.308960,662.872009 1260.288574,662.847900 
	C1248.790527,662.710022 1237.289917,662.780762 1225.790161,662.780579 
	C1221.003662,662.780518 1216.217163,662.780579 1211.226318,662.780579 
	C1211.226318,648.665466 1211.226318,635.124512 1211.226318,621.372803 
	C1212.372559,621.278015 1213.176636,621.154480 1213.980957,621.153564 
	C1225.480713,621.140076 1236.982178,621.032715 1248.479492,621.199341 
	C1252.761108,621.261414 1254.574585,619.596313 1254.468750,615.336304 
	C1254.332275,609.839966 1254.492798,604.336975 1254.435181,598.837769 
	C1254.372437,592.864746 1253.915649,592.444397 1247.735596,592.430969 
	C1237.235840,592.408203 1226.732422,592.268433 1216.238037,592.503723 
	C1212.274170,592.592651 1210.630005,591.713867 1210.761841,587.325378 
	C1211.076904,576.835022 1211.040039,566.324402 1210.774414,555.831299 
	C1210.673218,551.833496 1211.907227,550.722290 1215.856201,550.777527 
	C1231.186157,550.991882 1246.521729,550.793274 1261.853638,550.918823 
	C1265.499756,550.948669 1266.995361,549.674316 1266.870483,545.970886 
	C1266.685181,540.477234 1266.827637,534.972656 1266.821899,529.472778 
	C1266.814575,522.456360 1266.549194,522.167664 1259.496582,522.163574 
	C1236.330444,522.150208 1213.164185,522.151733 1189.998047,522.162476 
	C1182.809326,522.165833 1182.160767,522.846985 1182.159790,530.256042 
	C1182.155762,561.588745 1182.157837,592.921448 1182.157959,624.254150 
	C1182.157959,644.420410 1182.173706,664.586670 1182.145264,684.752930 
	C1182.140015,688.463440 1182.661865,691.183899 1187.521851,691.156006 
	C1212.353760,691.013550 1237.187256,691.049316 1262.019775,691.138916 
	C1265.366577,691.150940 1266.950073,690.145203 1266.861084,686.592712 
	C1266.681396,679.431763 1266.728638,672.265198 1266.333252,664.264954 
M2015.690430,556.595947 
	C2014.920532,552.006348 2016.792114,550.662231 2021.422974,550.752991 
	C2036.408447,551.046692 2051.404053,550.773987 2066.393555,550.925598 
	C2070.325928,550.965332 2071.801025,549.427429 2071.709717,545.630981 
	C2071.578125,540.137390 2071.693359,534.638245 2071.676514,529.141541 
	C2071.656738,522.675293 2071.152344,522.169922 2064.441895,522.165771 
	C2041.122314,522.151306 2017.802734,522.151917 1994.483154,522.165405 
	C1987.564209,522.169434 1986.936768,522.837952 1986.936401,530.002197 
	C1986.932983,581.138611 1986.934448,632.275085 1986.935059,683.411499 
	C1986.935181,684.410889 1986.905640,685.412109 1986.955444,686.409241 
	C1987.113281,689.568604 1988.499146,691.149170 1991.958374,691.137024 
	C2016.943359,691.049011 2041.929077,691.037109 2066.913818,691.149597 
	C2070.447266,691.165466 2071.717529,689.733948 2071.689941,686.449463 
	C2071.641113,680.619995 2071.437500,674.776794 2071.753174,668.963989 
	C2072.020508,664.035156 2069.930420,662.645996 2065.288330,662.708923 
	C2050.633057,662.907776 2035.973267,662.782104 2021.315308,662.782043 
	C2019.564941,662.782043 2017.814453,662.782043 2015.972168,662.782043 
	C2015.972168,648.564453 2015.972168,635.138916 2015.972168,621.143188 
	C2018.032715,621.143188 2019.817017,621.143372 2021.601318,621.143188 
	C2032.261719,621.142090 2042.922852,621.065918 2053.582031,621.178223 
	C2057.589355,621.220520 2059.344482,619.684814 2059.192383,615.553040 
	C2058.984131,609.897400 2058.856934,604.209656 2059.226318,598.570496 
	C2059.556396,593.527039 2057.352539,592.260254 2052.761719,592.357971 
	C2042.439087,592.577637 2032.101196,592.194824 2021.784912,592.530823 
	C2017.108643,592.683044 2015.373047,591.528625 2015.575439,586.551514 
	C2015.967529,576.906494 2015.690063,567.234253 2015.690430,556.595947 
M2798.927979,429.519165 
	C2803.345703,432.184265 2807.962891,434.575348 2812.118652,437.600433 
	C2815.487305,440.052673 2818.471680,440.076080 2822.263184,438.768463 
	C2875.720947,420.332031 2929.224854,402.029205 2982.715088,383.686310 
	C2995.111572,379.435333 3007.497803,375.155670 3020.249023,370.765228 
	C3011.305176,357.058411 3002.148926,344.306824 2986.931641,335.993073 
	C2988.090576,341.998932 2984.707031,343.623871 2980.578125,344.948792 
	C2968.716553,348.755127 2956.885986,352.663361 2945.096191,356.686676 
	C2899.922852,372.102081 2854.770996,387.581451 2809.608887,403.029877 
	C2797.635010,407.125671 2785.652832,411.196014 2773.099365,415.473999 
	C2781.959717,420.275635 2790.131104,424.703949 2798.927979,429.519165 
M2793.645508,575.820190 
	C2789.568359,536.847656 2782.718994,498.410522 2770.880371,460.992310 
	C2767.000488,448.729706 2762.410156,436.691895 2757.902832,423.862030 
	C2752.218506,430.277527 2747.367188,435.973328 2742.253662,441.423004 
	C2740.020996,443.802246 2739.752441,445.911713 2740.724121,449.017334 
	C2748.980225,475.404236 2755.807129,502.145477 2759.500244,529.595398 
	C2762.731445,553.614258 2763.646973,577.662476 2760.013672,601.747498 
	C2757.664307,617.322815 2753.036865,632.166565 2745.700684,646.580383 
	C2753.310547,649.755371 2760.625977,652.864136 2768.003418,655.817810 
	C2768.979004,656.208252 2770.362549,656.079956 2771.402344,655.731140 
	C2780.208984,652.777466 2788.979736,649.716797 2798.555420,646.414246 
	C2796.957275,623.154358 2795.361816,599.937378 2793.645508,575.820190 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M2665.232910,148.782166 
	C2675.533203,163.077667 2685.802734,177.395279 2696.164795,191.646011 
	C2697.812012,193.911652 2699.693848,196.074387 2701.768799,197.951187 
	C2736.583496,229.437744 2771.447266,260.870575 2806.296387,292.319092 
	C2807.776611,293.655029 2809.223877,295.027527 2810.822754,296.509247 
	C2804.631348,303.316833 2798.503906,310.054474 2792.078125,317.119812 
	C2782.439453,308.809906 2773.050293,300.715271 2763.661133,292.620605 
	C2763.310547,292.915558 2762.959717,293.210480 2762.608887,293.505402 
	C2775.400391,310.673157 2788.191895,327.840881 2801.222900,345.329987 
	C2805.240967,339.840881 2808.363770,333.327698 2817.361328,335.660645 
	C2818.290283,335.843323 2818.574707,335.793396 2818.859131,335.743439 
	C2818.658691,335.410309 2818.458008,335.077209 2818.257324,334.744049 
	C2816.690186,333.031464 2815.007324,331.409546 2813.580322,329.587158 
	C2810.763428,325.989044 2807.776123,324.137939 2802.781738,329.437592 
	C2802.781738,326.449890 2802.658936,324.878357 2802.819824,323.336487 
	C2802.952637,322.066040 2803.422119,320.830780 2803.742432,319.579895 
	C2802.323242,319.771881 2800.875977,319.851746 2799.494385,320.194855 
	C2798.554932,320.428101 2797.707520,321.030243 2795.495117,322.118774 
	C2795.654297,319.861084 2795.213135,318.013367 2795.942383,317.106628 
	C2800.315918,311.667664 2804.958496,306.444794 2809.572754,301.077545 
	C2816.141846,303.784607 2805.503906,309.414612 2812.230469,312.123199 
	C2813.362061,310.604126 2814.633545,308.897369 2815.828613,307.293030 
	C2822.470947,310.664429 2815.641602,313.423309 2816.238037,316.512268 
	C2824.063965,323.703125 2831.840332,330.949860 2839.791504,337.999695 
	C2840.601562,338.718018 2842.521484,338.550873 2843.821289,338.283936 
	C2848.050049,337.415649 2852.183594,335.999329 2856.438965,335.365631 
	C2863.616455,334.296753 2868.163574,338.277954 2867.902832,345.540436 
	C2867.760986,349.481323 2867.195312,353.604218 2865.794922,357.251099 
	C2864.158447,361.513855 2864.995605,364.489777 2868.171875,367.356567 
	C2869.763916,368.793365 2871.105469,370.507538 2873.046143,372.626587 
	C2869.463135,373.869720 2866.315918,374.961761 2863.010986,376.108459 
	C2861.683594,374.245117 2860.475342,372.549164 2858.457764,369.717316 
	C2856.214844,380.917206 2847.194092,381.635406 2839.554688,384.337097 
	C2822.163086,390.487640 2804.715576,396.484131 2787.392334,402.821533 
	C2783.978516,404.070435 2782.059570,403.305878 2779.667725,400.908417 
	C2735.766357,356.908264 2691.755371,313.017578 2647.883789,268.987976 
	C2645.194092,266.288422 2643.402344,265.825867 2639.967529,267.789795 
	C2586.221436,298.520905 2532.373779,329.074402 2478.619629,359.791534 
	C2477.069580,360.677216 2475.454102,362.825989 2475.285645,364.526093 
	C2474.252441,374.964813 2473.777100,385.458221 2472.779785,395.901306 
	C2472.457764,399.275909 2473.418457,400.892670 2476.480225,402.367462 
	C2508.374268,417.730072 2541.567139,429.633942 2575.393066,439.881683 
	C2608.585693,449.937744 2642.323975,457.721619 2676.659180,462.490814 
	C2695.438965,465.099335 2714.438477,466.125763 2733.338867,467.866241 
	C2734.484863,467.971802 2735.630615,468.083038 2737.101807,468.222473 
	C2738.669434,475.931610 2740.224365,483.578400 2741.951660,492.071503 
	C2726.860107,493.454559 2712.174316,495.100647 2697.444580,496.097382 
	C2639.744873,500.001892 2583.629395,490.784760 2528.179932,475.651062 
	C2487.288818,464.490692 2446.988281,451.766663 2409.321777,432.004700 
	C2383.350830,418.378815 2359.375732,401.997894 2340.817139,378.690582 
	C2321.088379,353.913940 2312.679688,325.899323 2315.717285,294.345520 
	C2318.676270,263.613922 2331.006348,236.339142 2346.885986,208.694199 
	C2349.373291,257.960510 2363.431152,301.732666 2394.897217,340.073029 
	C2395.607178,334.727722 2396.534180,330.337524 2396.671875,325.922729 
	C2396.789551,322.151611 2398.606445,320.530579 2401.751709,319.007263 
	C2434.865479,302.970520 2467.937744,286.846893 2500.920166,270.542206 
	C2503.865967,269.086121 2506.739746,266.622528 2508.569092,263.901978 
	C2531.230469,230.194107 2553.692139,196.351700 2576.493896,162.110077 
	C2582.751709,169.124298 2588.868164,175.980347 2595.116455,182.983963 
	C2580.178955,204.611954 2565.445557,225.944550 2550.712158,247.277161 
	C2550.961182,247.630341 2551.210449,247.983536 2551.459717,248.336716 
	C2575.903076,235.165970 2600.346436,221.995224 2625.263672,208.569092 
	C2622.367920,203.505722 2619.396240,198.758545 2616.910400,193.769516 
	C2615.710449,191.361115 2614.881836,188.509979 2614.820068,185.837662 
	C2614.583008,175.575668 2614.724365,165.304962 2614.724365,154.220047 
	C2608.727295,159.599121 2603.215820,164.542725 2597.528809,169.643677 
	C2598.714600,172.024124 2599.812012,174.227066 2601.057861,176.728043 
	C2599.715820,177.941742 2598.400391,179.131226 2597.127930,180.282028 
	C2587.581543,172.595764 2578.833984,161.090775 2580.390869,157.941254 
	C2582.403076,158.961792 2584.418213,159.983643 2586.816650,161.200058 
	C2595.205811,151.793930 2603.581299,142.333908 2612.062988,132.970001 
	C2613.297363,131.607178 2615.039062,130.703644 2616.946045,130.049835 
	C2619.181641,131.353424 2621.017334,132.194717 2623.220947,133.058151 
	C2628.308105,135.160065 2633.119141,137.059738 2637.705322,139.399933 
	C2639.813965,140.475800 2641.964111,142.085648 2643.279297,144.010910 
	C2685.423584,205.698105 2727.466309,267.454742 2769.528809,329.197968 
	C2776.808350,339.883911 2784.108398,350.556000 2791.494385,361.374390 
	C2797.007080,353.664215 2797.039062,353.245361 2792.121582,346.452026 
	C2768.807617,314.246521 2745.640869,281.932312 2722.078613,249.909149 
	C2712.468994,236.848969 2703.050537,223.897324 2700.186768,207.425339 
	C2698.933838,200.218048 2695.262207,194.172562 2691.024902,188.279709 
	C2681.896240,175.584610 2673.114014,162.640411 2664.450439,149.543762 
	C2664.884521,149.120346 2665.058594,148.951263 2665.232910,148.782166 
M2630.494141,258.357147 
	C2630.834961,257.958527 2631.175781,257.559875 2631.516602,257.161346 
	C2631.013916,257.443909 2630.511475,257.726471 2629.470459,258.030334 
	C2629.153809,258.182678 2628.837158,258.335022 2627.885742,258.783997 
	C2606.277588,270.438354 2584.670898,282.095398 2563.061035,293.746490 
	C2526.906982,313.239319 2490.735107,332.699768 2454.647705,352.315125 
	C2453.074463,353.170288 2451.450195,355.332092 2451.238281,357.055878 
	C2450.142090,365.972900 2449.453369,374.941986 2448.755615,383.903259 
	C2448.669922,385.003448 2449.021484,386.704163 2449.779785,387.207062 
	C2453.324463,389.557068 2457.082520,391.584625 2461.309570,394.044769 
	C2462.122314,383.939423 2463.023438,374.539307 2463.553467,365.118317 
	C2463.726318,362.041565 2465.044189,360.444855 2467.525635,358.925201 
	C2504.114502,336.516144 2540.669922,314.052826 2577.186768,291.526886 
	C2594.555908,280.812378 2611.826904,269.938843 2629.782471,258.963013 
	C2629.894775,258.865692 2630.102295,258.766541 2630.100586,258.671295 
	C2630.095947,258.431641 2629.997070,258.193817 2630.494141,258.357147 
M2814.630371,340.908661 
	C2810.507080,340.915100 2808.351562,343.619904 2806.776123,346.877960 
	C2801.203125,358.404388 2795.621582,369.928833 2790.238770,381.544556 
	C2787.616699,387.202698 2789.392578,392.434174 2794.265869,394.758484 
	C2798.927979,396.982147 2804.243408,394.829437 2806.933594,389.236816 
	C2812.411133,377.848389 2817.811035,366.419098 2823.011719,354.902313 
	C2826.433105,347.326019 2823.673584,342.477509 2814.630371,340.908661 
z"/>
            <path fill="#F2B40A" opacity="1.000000" stroke="none"
                d="
M2673.389648,70.578133 
	C2621.458496,61.541039 2569.608398,57.299274 2517.301758,58.973362 
	C2478.275879,60.222401 2439.577637,64.052711 2401.438232,72.708321 
	C2400.173584,72.995323 2398.833984,72.951523 2397.529297,73.061905 
	C2397.400635,72.628563 2397.272217,72.195229 2397.143799,71.761887 
	C2412.156982,66.609093 2427.041748,61.038738 2442.207031,56.381580 
	C2488.052979,42.302738 2535.065430,34.294254 2582.763184,29.802584 
	C2616.317139,26.642836 2649.922363,25.298906 2683.586914,26.185497 
	C2728.279297,27.362524 2772.656738,31.643770 2816.263428,41.998772 
	C2859.677490,52.308105 2901.382812,66.730026 2937.068359,94.696762 
	C2963.519043,115.426071 2981.934082,141.370117 2987.559082,175.237457 
	C2991.376953,198.223465 2988.694092,220.715363 2982.124512,242.846252 
	C2975.741943,264.347931 2966.385498,284.552704 2954.871338,303.774872 
	C2954.545410,304.319244 2954.084717,304.782837 2953.156006,305.952362 
	C2953.525879,302.015533 2953.843018,298.854126 2954.117188,295.689026 
	C2957.469727,257.029907 2946.425293,222.727676 2923.095947,191.998795 
	C2903.383545,166.034317 2877.942383,146.941788 2850.192383,130.620987 
	C2809.338135,106.592987 2765.001953,91.421623 2719.242432,80.132118 
	C2704.233887,76.429314 2688.959717,73.804291 2673.389648,70.578133 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M3088.570312,530.571411 
	C3082.858154,549.141541 3082.823730,549.040771 3064.776611,555.214111 
	C3003.105225,576.310120 2941.460693,597.485107 2879.801758,618.617798 
	C2878.285889,619.137390 2876.720947,619.513672 2874.524414,620.144714 
	C2877.916016,613.638977 2881.265625,607.939148 2883.953369,601.942688 
	C2904.832764,555.364319 2897.096191,512.785889 2860.663818,476.182709 
	C2851.652344,467.128754 2841.446777,459.262695 2831.780029,450.862152 
	C2830.684814,449.910370 2829.524414,449.033478 2827.815918,447.655304 
	C2840.431396,443.297668 2852.430908,439.125610 2864.448242,435.006500 
	C2917.769287,416.730072 2971.091553,398.456512 3024.441650,380.264496 
	C3026.006104,379.730927 3028.199219,379.484283 3029.569580,380.167114 
	C3055.856934,393.266235 3077.985352,410.782410 3089.739746,438.750763 
	C3099.116699,461.062195 3098.755615,484.203705 3094.447266,507.471008 
	C3093.027100,515.138977 3090.659912,522.631592 3088.570312,530.571411 
M2934.381104,505.122925 
	C2925.774658,480.374084 2909.151855,462.012970 2888.177979,447.111084 
	C2885.253662,445.033264 2882.271973,444.216064 2879.928711,447.630371 
	C2877.604980,451.015961 2879.526123,453.517487 2882.298584,455.653229 
	C2886.385986,458.801910 2890.554688,461.866089 2894.445068,465.246735 
	C2917.587646,485.357758 2930.135742,510.482727 2929.700928,541.451660 
	C2929.508301,555.171082 2926.787842,568.542236 2922.557373,581.594971 
	C2921.457764,584.988159 2921.672119,588.142334 2925.499268,589.409912 
	C2929.347656,590.684509 2931.280518,588.285522 2932.367676,584.844421 
	C2940.616455,558.729065 2943.236084,532.455872 2934.381104,505.122925 
M3014.627930,423.858734 
	C3015.845215,424.995789 3017.062256,426.133209 3018.280029,427.269836 
	C3039.055176,446.660919 3050.133545,470.319641 3050.011475,498.981140 
	C3049.949951,513.452515 3046.986816,527.398071 3042.751221,541.128662 
	C3041.670654,544.631836 3042.654297,547.163696 3046.067139,548.266296 
	C3049.442871,549.357056 3051.551025,547.325928 3052.509521,544.350647 
	C3058.961670,524.320496 3062.222900,503.885162 3059.233887,482.853149 
	C3054.431885,449.061646 3035.070312,424.811432 3008.100830,405.646851 
	C3005.479004,403.783752 3002.778564,403.240845 3000.573975,406.006561 
	C2998.253418,408.917664 2999.197266,411.630371 3001.930908,413.808533 
	C3005.968018,417.025208 3010.044922,420.191772 3014.627930,423.858734 
M3012.940674,556.386108 
	C3013.464600,554.633850 3014.017334,552.889587 3014.508789,551.128174 
	C3020.317139,530.303162 3022.434082,509.204285 3017.561768,487.959839 
	C3010.720703,458.128540 2992.283936,436.439270 2967.811768,419.249512 
	C2965.149902,417.379669 2962.379639,417.205048 2960.297852,419.957947 
	C2958.022217,422.966736 2959.250244,425.535187 2961.967529,427.681976 
	C2966.668213,431.395660 2971.502686,434.964905 2975.971436,438.942413 
	C2998.303467,458.820435 3010.312012,483.499298 3009.953369,513.677856 
	C3009.790283,527.410522 3007.059570,540.769653 3002.911865,553.827637 
	C3001.825684,557.246033 3001.701172,560.339050 3005.451904,561.769897 
	C3009.536621,563.328186 3011.626709,560.776733 3012.940674,556.386108 
M2954.524414,474.035522 
	C2968.299316,494.925659 2972.200439,517.930969 2968.488525,542.305664 
	C2967.117676,551.308044 2964.443604,560.112915 2962.339600,569.002075 
	C2961.569824,572.253296 2962.556885,575.220642 2965.780273,575.557617 
	C2967.739746,575.762512 2970.635986,573.946533 2971.892090,572.174194 
	C2973.444092,569.984009 2973.809570,566.918701 2974.552002,564.194519 
	C2981.349121,539.255249 2982.844971,514.319397 2973.852295,489.566101 
	C2965.608643,466.874481 2950.344971,449.612610 2931.195068,435.468323 
	C2925.413574,431.198059 2922.125000,430.725159 2919.986572,433.831818 
	C2917.827148,436.969757 2919.184814,439.556183 2925.236816,443.991241 
	C2936.472900,452.225006 2946.308594,461.836823 2954.524414,474.035522 
z"/>
            <path fill="#F2B40A" opacity="1.000000" stroke="none"
                d="
M2364.806641,627.000000 
	C2364.806885,594.347534 2364.801270,562.195129 2364.811523,530.042664 
	C2364.813965,523.207458 2365.779785,522.216187 2372.555420,522.174744 
	C2379.718750,522.130920 2386.893555,522.411987 2394.042236,522.083740 
	C2399.402344,521.837585 2401.818115,524.120789 2402.926758,529.198486 
	C2409.804199,560.698486 2416.856934,592.160278 2423.856445,623.633606 
	C2424.089111,624.679260 2424.375244,625.713013 2425.706055,626.776550 
	C2427.794922,617.491455 2429.893066,608.208374 2431.970947,598.920776 
	C2437.195312,575.564331 2442.527832,552.230835 2447.534180,528.827576 
	C2448.573242,523.969543 2450.894287,522.039062 2455.676270,522.128784 
	C2463.336914,522.272522 2471.002441,522.221680 2478.665039,522.144348 
	C2483.078369,522.099792 2485.278320,523.553650 2485.265625,528.544495 
	C2485.132324,580.687805 2485.146729,632.831543 2485.251465,684.974976 
	C2485.260254,689.430603 2483.940430,691.435547 2479.248047,691.152100 
	C2474.434326,690.861267 2469.589600,691.090454 2464.758301,691.086975 
	C2456.964111,691.081299 2456.787842,690.902527 2456.786133,682.833008 
	C2456.782715,665.673950 2456.785156,648.514832 2456.785156,631.355774 
	C2456.785156,618.869446 2456.785400,606.383118 2456.785400,593.896790 
	C2456.503662,593.822937 2456.221924,593.749146 2455.939941,593.675293 
	C2454.994629,597.552368 2453.971191,601.412292 2453.116455,605.309204 
	C2447.384277,631.451416 2441.698242,657.603699 2435.972656,683.747375 
	C2434.408203,690.890686 2434.114990,691.117981 2426.677246,691.079712 
	C2415.054688,691.019653 2416.133057,692.610901 2413.447266,680.593567 
	C2407.211670,652.692383 2401.159424,624.750305 2395.016846,596.828186 
	C2394.782227,595.762207 2394.383545,594.732483 2393.147461,593.692505 
	C2393.147461,594.869263 2393.147461,596.045959 2393.147461,597.222717 
	C2393.148926,626.376465 2393.079346,655.530640 2393.224609,684.683655 
	C2393.247803,689.341187 2391.891113,691.458740 2386.953857,691.157593 
	C2381.808594,690.843689 2376.629150,691.104431 2371.464844,691.082520 
	C2365.601318,691.057556 2364.839844,690.374329 2364.825928,684.474976 
	C2364.781006,665.483398 2364.807617,646.491699 2364.806641,627.000000 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M1384.698730,604.272095 
	C1385.969849,610.444397 1387.165161,616.199768 1388.360474,621.955200 
	C1388.742920,621.930542 1389.125366,621.905884 1389.507812,621.881226 
	C1390.085205,615.560425 1390.674194,609.240601 1391.238037,602.918579 
	C1393.469849,577.902161 1395.761597,552.890747 1397.848755,527.862244 
	C1398.165649,524.062866 1399.926270,522.326904 1403.391235,522.243774 
	C1409.552490,522.095886 1415.720825,522.116455 1421.883667,522.221191 
	C1425.976685,522.290771 1427.284912,524.660583 1426.842651,528.548645 
	C1425.000488,544.741699 1423.290283,560.949707 1421.460938,577.144226 
	C1418.586548,602.587646 1415.650024,628.023926 1412.750610,653.464478 
	C1411.508301,664.364624 1410.282593,675.266663 1409.070679,686.170166 
	C1408.701904,689.486816 1407.192261,691.233215 1403.562378,691.135010 
	C1397.235352,690.963806 1390.895142,690.933167 1384.570435,691.144958 
	C1380.579834,691.278564 1378.918091,689.329834 1378.109009,685.759033 
	C1373.184692,664.027527 1368.185181,642.313049 1363.202881,620.594604 
	C1361.346680,612.503235 1359.469238,604.416687 1356.747925,596.115356 
	C1355.868896,599.509399 1354.914185,602.885925 1354.123047,606.300293 
	C1348.043091,632.538940 1341.931519,658.770691 1335.997070,685.042358 
	C1334.969604,689.590820 1332.816040,691.476013 1328.062988,691.174072 
	C1322.420532,690.815735 1316.724365,690.847290 1311.076904,691.164062 
	C1306.356323,691.428772 1304.577881,689.476990 1304.137085,684.928162 
	C1302.132080,664.235535 1299.963013,643.558105 1297.744995,622.886780 
	C1294.977417,597.093323 1292.105713,571.310913 1289.273804,545.524292 
	C1288.639160,539.744019 1288.031616,533.960083 1287.321045,528.188965 
	C1286.852173,524.381592 1288.633545,522.360718 1292.250977,522.261353 
	C1298.576904,522.087463 1304.913574,522.111572 1311.240845,522.259644 
	C1314.569824,522.337585 1316.276733,524.317566 1316.544189,527.691772 
	C1318.385864,550.911865 1320.247803,574.130310 1322.161987,597.344482 
	C1322.833984,605.494873 1323.671509,613.631653 1325.556885,621.824097 
	C1327.734253,611.515137 1329.917603,601.207458 1332.087891,590.896973 
	C1336.504395,569.914673 1340.956299,548.939636 1345.288452,527.939880 
	C1346.095703,524.027466 1348.219849,522.167603 1352.143066,522.166504 
	C1369.591309,522.161682 1367.115723,520.841797 1370.247070,535.516541 
	C1375.104614,558.282104 1379.837402,581.074280 1384.698730,604.272095 
z"/>
            <path fill="#F2B40A" opacity="1.000000" stroke="none"
                d="
M2793.593506,507.459625 
	C2787.661865,479.692017 2780.006104,452.867157 2769.438477,426.045654 
	C2770.971680,426.493530 2771.846924,426.605927 2772.584961,426.985535 
	C2800.494873,441.337799 2827.240723,457.446838 2849.773438,479.634491 
	C2867.320312,496.912903 2880.812500,516.614319 2884.384277,541.704895 
	C2887.173096,561.295837 2883.215332,579.879578 2874.602295,597.407715 
	C2870.214111,606.337524 2864.675049,614.706909 2859.536865,623.257812 
	C2858.721924,624.614380 2857.475586,626.166382 2856.086670,626.654114 
	C2840.263672,632.209900 2824.374023,637.576538 2808.364502,643.040771 
	C2807.590820,629.186218 2806.917236,615.756653 2806.075439,602.337646 
	C2804.145264,571.570679 2800.384766,541.037598 2794.138184,510.830780 
	C2793.936279,509.854523 2793.850098,508.854340 2793.593506,507.459625 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M2128.686279,547.249878 
	C2136.605713,569.493103 2144.394775,591.368225 2152.184082,613.243347 
	C2152.558838,613.186157 2152.933838,613.128967 2153.308838,613.071777 
	C2153.308838,611.353333 2153.308838,609.634888 2153.308838,607.916443 
	C2153.309082,581.753357 2153.306152,555.590210 2153.311035,529.427124 
	C2153.312256,522.535889 2153.675049,522.182983 2160.738770,522.162659 
	C2165.904785,522.147827 2171.074707,522.288452 2176.235352,522.123413 
	C2180.904053,521.974060 2182.817139,523.927124 2182.770752,528.661926 
	C2182.618896,544.158325 2182.713867,559.657166 2182.713867,575.155029 
	C2182.713867,610.650208 2182.714111,646.145386 2182.713867,681.640564 
	C2182.713867,691.090576 2182.713623,691.090820 2173.047363,691.091064 
	C2168.547852,691.091125 2164.034912,690.873657 2159.553223,691.156616 
	C2155.849121,691.390442 2154.218994,689.698730 2153.062988,686.435852 
	C2143.504150,659.454163 2133.832275,632.512390 2124.189941,605.560303 
	C2123.524902,603.701660 2122.822021,601.856567 2121.356201,600.039551 
	C2121.290771,601.187988 2121.168701,602.336487 2121.168213,603.484924 
	C2121.158936,630.647888 2121.058594,657.811707 2121.259033,684.973145 
	C2121.295166,689.852356 2119.710449,691.466248 2114.930664,691.172363 
	C2109.286133,690.825378 2103.591064,690.855713 2097.941895,691.163574 
	C2093.194824,691.422241 2091.821045,689.267090 2091.858887,684.935059 
	C2091.975830,671.604614 2091.900879,658.272400 2091.900635,644.940918 
	C2091.900635,606.612793 2091.898438,568.284668 2091.902344,529.956543 
	C2091.903076,522.870422 2092.571045,522.186584 2099.517334,522.163452 
	C2104.683350,522.146240 2109.849121,522.186584 2115.015137,522.158569 
	C2118.239258,522.141113 2120.209717,523.467285 2121.281006,526.693237 
	C2123.534912,533.479553 2126.111816,540.158630 2128.686279,547.249878 
z"/>
            <path fill="#F2B40A" opacity="1.000000" stroke="none"
                d="
M1813.460083,575.535522 
	C1818.092529,588.370667 1822.575195,600.844543 1827.057983,613.318420 
	C1827.416138,613.297913 1827.774170,613.277466 1828.132324,613.256958 
	C1828.132324,611.408081 1828.132080,609.559143 1828.132202,607.710266 
	C1828.132324,581.380859 1828.126953,555.051514 1828.137451,528.722107 
	C1828.139771,522.821289 1828.734985,522.227112 1834.777710,522.174927 
	C1840.109741,522.128845 1845.442993,522.125977 1850.775024,522.176575 
	C1856.544556,522.231323 1857.500000,523.119751 1857.513916,528.874146 
	C1857.561035,548.371094 1857.533081,567.868225 1857.533203,587.365295 
	C1857.533447,619.360474 1857.537964,651.355713 1857.529419,683.350891 
	C1857.527344,690.919739 1857.339478,691.084412 1849.634766,691.087158 
	C1844.802124,691.088867 1839.947876,690.804199 1835.143188,691.170471 
	C1830.806885,691.501038 1829.005981,689.584656 1827.647217,685.723267 
	C1818.036255,658.410034 1808.229126,631.165710 1798.473755,603.903381 
	C1797.986572,602.541626 1797.398071,601.216064 1796.056396,599.897156 
	C1796.056396,601.257690 1796.056641,602.618225 1796.056641,603.978760 
	C1796.056763,630.974731 1795.950928,657.971436 1796.153687,684.965881 
	C1796.190552,689.873962 1794.567993,691.458252 1789.795654,691.167908 
	C1784.150757,690.824402 1778.455811,690.849976 1772.807129,691.160217 
	C1768.065186,691.420715 1766.733765,689.320984 1766.756714,684.951111 
	C1766.869873,663.454895 1766.807251,641.957825 1766.807129,620.461060 
	C1766.806885,590.298889 1766.804932,560.136780 1766.808838,529.974609 
	C1766.809814,522.642883 1767.288574,522.181885 1774.841187,522.166260 
	C1779.340454,522.156921 1783.847900,522.332397 1788.336792,522.116516 
	C1792.584839,521.912170 1795.029175,523.396362 1796.481445,527.648804 
	C1801.912598,543.551636 1807.673340,559.341797 1813.460083,575.535522 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M2575.229004,688.452026 
	C2570.170654,689.446106 2565.468262,690.887634 2560.741699,690.972717 
	C2544.424805,691.266479 2528.097900,690.952393 2511.778809,691.172791 
	C2507.083496,691.236267 2505.704590,689.397827 2505.711426,684.994080 
	C2505.791504,632.697083 2505.780762,580.399902 2505.722900,528.102844 
	C2505.718994,524.564270 2506.581299,522.158630 2510.590088,522.197571 
	C2528.731445,522.373840 2546.912354,521.902771 2565.002197,522.969421 
	C2581.275391,523.929138 2589.939453,533.381836 2590.672363,549.867798 
	C2591.300293,563.997192 2591.048096,578.177979 2590.796631,592.329163 
	C2590.672852,599.309509 2586.144775,603.677124 2579.220703,606.902832 
	C2589.592285,610.854797 2591.307617,618.658508 2590.960693,627.824463 
	C2590.450928,641.287231 2590.840088,654.798340 2589.929932,668.226685 
	C2589.308350,677.396057 2584.337646,684.440735 2575.229004,688.452026 
M2561.714844,626.367004 
	C2559.877686,624.654724 2558.156494,621.641907 2556.182373,621.465820 
	C2549.335449,620.855164 2542.400635,621.230164 2535.490234,621.230164 
	C2535.490234,635.360168 2535.490234,648.880188 2535.490234,662.770020 
	C2541.944824,662.770020 2548.059082,662.895508 2554.165771,662.731812 
	C2559.391113,662.591736 2561.946533,660.279968 2562.042725,655.090637 
	C2562.214600,645.802368 2561.968262,636.506287 2561.714844,626.367004 
M2542.567139,550.735657 
	C2540.286377,550.735657 2538.005615,550.735657 2535.488525,550.735657 
	C2535.488525,564.977051 2535.488525,578.650146 2535.488525,592.654846 
	C2542.099854,592.654846 2548.389893,592.900085 2554.650391,592.573120 
	C2559.214111,592.334717 2562.033203,589.588989 2562.087158,584.817017 
	C2562.186523,576.010986 2562.206543,567.201172 2562.060791,558.396240 
	C2561.981934,553.636108 2559.224365,551.089233 2554.505859,550.874634 
	C2550.857178,550.708679 2547.197998,550.773254 2542.567139,550.735657 
z"/>
            <path fill="#F2B40A" opacity="1.000000" stroke="none"
                d="
M1085.140747,691.087769 
	C1077.010742,691.071472 1076.853027,690.923462 1076.852539,683.251770 
	C1076.849365,632.128235 1076.849487,581.004761 1076.852661,529.881226 
	C1076.853027,522.728516 1077.383789,522.115906 1084.455933,522.181213 
	C1101.761841,522.341064 1119.105713,521.945740 1136.361206,522.985962 
	C1152.454590,523.955994 1161.306519,533.788574 1161.855591,550.065857 
	C1162.327026,564.038513 1162.168335,578.041138 1161.943481,592.024963 
	C1161.829956,599.079712 1157.590454,603.639771 1150.775757,606.597656 
	C1152.170288,607.463074 1153.189331,608.149536 1154.257202,608.748657 
	C1158.652344,611.214355 1161.663208,615.121765 1161.707764,619.924988 
	C1161.857422,636.048889 1162.341797,652.261841 1160.910889,668.281067 
	C1159.615356,682.784912 1148.780396,690.992371 1134.080688,691.062561 
	C1117.927979,691.139709 1101.774658,691.085022 1085.140747,691.087769 
M1106.234497,643.499512 
	C1106.234497,649.761536 1106.234497,656.023560 1106.234497,662.649292 
	C1113.566162,662.649292 1120.332886,662.845520 1127.080200,662.570190 
	C1130.698242,662.422546 1132.944214,659.860779 1133.015991,656.319336 
	C1133.210693,646.707825 1133.207520,637.086609 1132.994507,627.475586 
	C1132.915649,623.914001 1130.546753,621.429321 1126.989868,621.274780 
	C1120.251953,620.981995 1113.492310,621.190125 1106.234619,621.190125 
	C1106.234619,628.629822 1106.234619,635.564819 1106.234497,643.499512 
M1106.947998,551.139404 
	C1106.710205,552.739868 1106.273804,554.339294 1106.266113,555.940857 
	C1106.208252,568.038574 1106.234619,580.136597 1106.234619,592.586060 
	C1113.248291,592.586060 1119.696289,592.856140 1126.109497,592.499207 
	C1131.093262,592.221802 1133.340942,588.796692 1133.372803,584.004333 
	C1133.427002,575.852783 1133.512695,567.695435 1133.268188,559.549988 
	C1133.075439,553.136414 1130.786743,550.985901 1124.299194,550.785889 
	C1118.814819,550.616760 1113.319946,550.786743 1106.947998,551.139404 
z"/>
            <path fill="#F2B50B" opacity="1.000000" stroke="none"
                d="
M922.397217,689.848999 
	C917.708435,673.150818 913.127136,656.821045 908.976562,640.382568 
	C907.927612,636.228394 906.298584,634.450378 901.979187,635.025818 
	C899.402283,635.369202 896.742188,635.088867 893.573120,635.088867 
	C893.573120,642.748047 893.573181,649.868713 893.573059,656.989380 
	C893.572815,666.486084 893.474854,675.984314 893.619263,685.478821 
	C893.678589,689.382263 892.558105,691.352539 888.218262,691.158936 
	C882.065918,690.884521 875.885132,690.907166 869.730225,691.150635 
	C865.485474,691.318542 864.060120,689.323853 864.105835,685.479980 
	C864.157288,681.148743 864.115173,676.816467 864.115173,672.484619 
	C864.115051,625.001038 864.113342,577.517395 864.117188,530.033813 
	C864.117737,522.825500 864.786865,522.168823 872.179016,522.164734 
	C888.006897,522.155945 903.837524,521.983337 919.661621,522.229797 
	C930.235046,522.394470 940.987671,523.889160 946.470520,534.280212 
	C949.515259,540.050537 951.079224,547.185974 951.271179,553.765625 
	C951.795349,571.733582 951.369324,589.735474 951.057251,607.719360 
	C950.871094,618.448425 946.647400,627.083740 936.221802,632.342224 
	C939.973999,646.574524 943.739197,660.808716 947.473572,675.051025 
	C948.486084,678.912598 949.644165,682.762756 950.234009,686.693420 
	C950.430847,688.004700 949.066101,690.799316 948.411865,690.800354 
	C939.829651,690.813782 931.246948,690.447815 922.397217,689.848999 
M908.433533,550.732727 
	C903.532166,550.732727 898.630737,550.732727 893.741211,550.732727 
	C893.741211,569.816101 893.741211,588.042603 893.741211,606.267151 
	C901.214111,606.267151 908.324036,606.453857 915.417419,606.191284 
	C919.174988,606.052246 921.804932,603.677185 921.846375,599.806641 
	C921.997681,585.669373 921.982483,571.528381 921.824707,557.391113 
	C921.781128,553.487183 919.143311,551.445374 915.377991,551.009460 
	C913.401794,550.780701 911.395020,550.816345 908.433533,550.732727 
z"/>
            <path fill="#F2B50B" opacity="1.000000" stroke="none"
                d="
M1029.398438,522.494873 
	C1047.982056,524.581787 1056.402100,533.622864 1056.625977,553.391296 
	C1057.029907,589.048767 1056.771240,624.714172 1056.696289,660.376038 
	C1056.689697,663.510742 1056.256714,666.701294 1055.579224,669.768066 
	C1052.615967,683.181030 1043.015259,690.975769 1029.272217,691.056152 
	C1011.941650,691.157471 994.609009,690.980286 977.279785,691.164917 
	C973.119385,691.209229 971.689026,689.735535 971.694336,685.677185 
	C971.763184,633.017334 971.761230,580.357300 971.692078,527.697388 
	C971.687073,523.861328 973.242554,522.148621 976.976868,522.167236 
	C994.303772,522.253540 1011.630737,522.327759 1029.398438,522.494873 
M1028.084717,654.995056 
	C1028.096069,625.691467 1028.110840,596.387817 1028.113770,567.084229 
	C1028.114014,564.088684 1028.218750,561.077759 1027.958984,558.101562 
	C1027.663086,554.711365 1026.145996,551.526062 1022.481750,551.318115 
	C1015.443542,550.918579 1008.366638,551.201782 1001.423584,551.201782 
	C1001.423584,588.536072 1001.423584,625.549255 1001.423584,662.761780 
	C1007.801697,662.761780 1013.782227,662.760376 1019.762695,662.762146 
	C1024.429810,662.763550 1027.348633,660.678284 1028.084717,654.995056 
z"/>
            <path fill="#F2B50D" opacity="1.000000" stroke="none"
                d="
M1552.142822,632.000000 
	C1552.142944,606.507019 1552.060059,581.513611 1552.215942,556.521545 
	C1552.245728,551.742798 1552.781372,546.871216 1553.839355,542.214050 
	C1556.351685,531.153015 1564.598877,523.572876 1575.921143,523.057068 
	C1589.690186,522.429871 1603.543213,522.305603 1617.297363,523.078308 
	C1630.543823,523.822449 1639.557861,533.022034 1640.721191,546.153992 
	C1641.527466,555.254578 1641.256470,564.451050 1641.451782,573.604980 
	C1641.527222,577.140320 1639.812256,578.729309 1636.237305,578.665833 
	C1630.240845,578.559265 1624.239624,578.554382 1618.243530,578.669250 
	C1614.482300,578.741211 1612.707764,577.286438 1612.871704,573.350891 
	C1613.058838,568.860046 1612.992554,564.353516 1612.894287,559.856934 
	C1612.758789,553.647095 1610.292480,551.071960 1604.068237,550.811096 
	C1599.743652,550.629761 1595.402222,550.654663 1591.074341,550.785461 
	C1584.015625,550.998779 1581.782104,553.161621 1581.660278,560.168030 
	C1581.515381,568.496521 1581.620972,576.829346 1581.620483,585.160339 
	C1581.619507,607.320740 1581.606079,629.481201 1581.626221,651.641602 
	C1581.634521,660.824524 1583.508789,662.690918 1592.787842,662.766602 
	C1596.950806,662.800598 1601.115723,662.725159 1605.278198,662.630920 
	C1610.171997,662.520020 1612.718018,659.667786 1612.829834,655.072266 
	C1613.052124,645.939392 1612.895630,636.797363 1612.895630,627.020508 
	C1609.528198,627.020508 1606.423950,626.961121 1603.322998,627.037109 
	C1600.190430,627.113831 1598.683594,625.634705 1598.683350,622.547363 
	C1598.682983,615.883850 1598.695923,609.220276 1598.691040,602.556763 
	C1598.688965,599.633362 1600.219360,598.342163 1603.047852,598.344360 
	C1614.377808,598.353210 1625.707886,598.346191 1637.037842,598.356201 
	C1640.207153,598.358948 1641.491943,600.147034 1641.469604,603.131287 
	C1641.315063,623.784241 1641.664429,644.457336 1640.838501,665.083435 
	C1640.237061,680.105103 1632.390137,689.229675 1617.689087,690.524048 
	C1603.187744,691.800903 1588.371338,691.372620 1573.852295,690.002991 
	C1561.441772,688.832214 1553.917725,679.919861 1553.038818,667.433411 
	C1552.221680,655.825378 1552.401855,644.147278 1552.142822,632.000000 
z"/>
            <path fill="#F2B50D" opacity="1.000000" stroke="none"
                d="
M2330.587646,687.747192 
	C2325.256592,688.975342 2320.294434,690.681946 2315.255859,690.949402 
	C2305.953369,691.443054 2296.606445,691.095886 2287.277832,691.093384 
	C2265.823242,691.087708 2255.715088,681.914001 2255.436279,660.377930 
	C2254.974609,624.735596 2255.245605,589.082642 2255.388428,553.434875 
	C2255.405518,549.166016 2256.058594,544.758057 2257.262451,540.663208 
	C2260.367188,530.105103 2268.033447,523.826416 2278.658203,523.150696 
	C2292.729248,522.255798 2306.935547,522.293274 2321.016602,523.101318 
	C2333.500000,523.817688 2342.388916,532.707520 2343.736816,545.200195 
	C2344.768799,554.762756 2344.443115,564.475220 2344.638672,574.122742 
	C2344.701172,577.198425 2342.960449,578.643616 2339.920898,578.637024 
	C2333.424316,578.622925 2326.927734,578.641052 2320.431152,578.626038 
	C2317.314453,578.618835 2315.952148,577.003235 2315.996582,573.913757 
	C2316.065918,569.083984 2316.113525,564.249390 2315.977295,559.422302 
	C2315.816162,553.709656 2313.431396,551.149841 2307.774658,550.854858 
	C2303.122803,550.612183 2298.444336,550.636536 2293.786865,550.804016 
	C2287.221924,551.040100 2284.927490,553.421875 2284.842041,560.166016 
	C2284.723877,569.493103 2284.808838,578.822754 2284.808594,588.151306 
	C2284.808105,609.307129 2284.798828,630.462952 2284.812744,651.618774 
	C2284.818848,660.852234 2286.648193,662.696472 2295.921631,662.764893 
	C2300.083740,662.795593 2304.246826,662.701416 2308.409180,662.628601 
	C2313.320312,662.542725 2315.831299,659.766174 2315.921387,655.106079 
	C2316.097900,645.967957 2315.973389,636.824036 2315.973389,627.026001 
	C2312.825684,627.026001 2309.890137,626.938965 2306.961670,627.048401 
	C2303.418213,627.180786 2301.764404,625.747314 2301.849609,622.049744 
	C2301.995361,615.723022 2301.996826,609.388000 2301.849609,603.061401 
	C2301.767822,599.544800 2303.425049,598.312500 2306.678711,598.323975 
	C2317.673096,598.362793 2328.667236,598.364868 2339.661621,598.323608 
	C2342.926270,598.311340 2344.706543,599.708496 2344.671631,603.065674 
	C2344.449707,624.373291 2344.496338,645.689087 2343.854980,666.984192 
	C2343.584717,675.957886 2339.066895,683.118652 2330.587646,687.747192 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M1958.277344,529.697144 
	C1964.838379,535.887512 1966.357544,543.721069 1966.759888,551.795532 
	C1967.115967,558.940369 1966.781982,566.117188 1966.894165,573.277649 
	C1966.954468,577.119507 1965.197632,578.708984 1961.445801,578.655090 
	C1955.284302,578.566528 1949.120117,578.591431 1942.957764,578.645325 
	C1939.599731,578.674683 1938.107056,577.128235 1938.170532,573.772095 
	C1938.258545,569.110046 1938.254883,564.443726 1938.168701,559.781494 
	C1938.052490,553.492188 1935.730469,551.059631 1929.390991,550.806396 
	C1924.901001,550.627014 1920.393555,550.637817 1915.902222,550.797058 
	C1909.626587,551.019409 1907.205811,553.419434 1907.020020,559.742432 
	C1906.843994,565.733582 1906.972778,571.733826 1906.972412,577.730042 
	C1906.971436,602.381348 1906.960449,627.032715 1906.978027,651.684021 
	C1906.984497,660.746948 1909.023193,662.755676 1918.205200,662.770996 
	C1922.532959,662.778198 1926.864380,662.750244 1931.188110,662.584229 
	C1935.607788,662.414673 1937.992920,659.787781 1938.076416,655.564575 
	C1938.260010,646.263672 1938.133423,636.956665 1938.133423,627.014648 
	C1934.777344,627.014648 1931.671875,627.007690 1928.566284,627.016602 
	C1925.492676,627.025391 1924.033081,625.636658 1924.086304,622.433105 
	C1924.194214,615.938965 1924.197632,609.440308 1924.079956,602.946411 
	C1924.022339,599.769165 1925.373657,598.336975 1928.499634,598.342346 
	C1939.659302,598.361511 1950.818970,598.351685 1961.978638,598.346741 
	C1964.917847,598.345398 1966.866211,599.528687 1966.834961,602.713318 
	C1966.623657,624.182861 1966.944092,645.679016 1965.933472,667.111938 
	C1965.247559,681.656921 1954.206177,690.897644 1939.597168,691.055908 
	C1928.438721,691.176819 1917.277710,691.132507 1906.118286,691.074646 
	C1889.510498,690.988464 1879.239136,681.508972 1878.150146,664.940002 
	C1877.626831,656.977051 1877.536865,648.972900 1877.567383,640.988525 
	C1877.685669,610.019043 1877.643677,579.044373 1878.253174,548.083313 
	C1878.546753,533.163940 1888.250122,523.641052 1903.279297,522.986206 
	C1916.216064,522.422485 1929.242432,522.243713 1942.136841,523.174866 
	C1947.553711,523.566040 1952.732422,527.253906 1958.277344,529.697144 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M507.606934,629.051636 
	C507.606750,648.035400 507.521210,666.528198 507.669800,685.019104 
	C507.705017,689.400085 506.502594,691.458069 501.707306,691.175537 
	C495.730591,690.823425 489.708435,690.890015 483.723022,691.158325 
	C479.492188,691.348022 478.086029,689.501221 478.112579,685.571106 
	C478.191376,673.909973 478.138214,662.247925 478.138123,650.586243 
	C478.137787,610.270142 478.134552,569.954102 478.141693,529.638000 
	C478.142883,522.970642 478.916260,522.199951 485.586334,522.164978 
	C490.584045,522.138733 495.582153,522.137634 500.579865,522.165344 
	C507.010193,522.201050 507.601257,522.814819 507.604034,529.432617 
	C507.612061,548.591125 507.607117,567.749573 507.607239,586.908081 
	C507.607269,588.685303 507.607239,590.462524 507.607239,592.500671 
	C516.646301,592.500671 525.051941,592.500671 533.937134,592.500671 
	C533.937134,590.481812 533.937134,588.693542 533.937134,586.905273 
	C533.937195,567.580200 533.931335,548.255127 533.940918,528.930054 
	C533.943848,522.944458 534.591309,522.234314 540.380615,522.174622 
	C546.210815,522.114502 552.042175,522.166443 557.872986,522.169312 
	C561.528320,522.171143 563.242981,523.759399 563.237915,527.652588 
	C563.169067,580.296692 563.171570,632.940857 563.229980,685.584961 
	C563.234497,689.572327 561.877441,691.342224 557.663025,691.156982 
	C551.677124,690.893799 545.662598,690.895325 539.676453,691.155212 
	C535.310852,691.344666 533.830688,689.689819 533.867188,685.346313 
	C534.029419,666.022644 533.937256,646.696777 533.937073,627.371704 
	C533.937073,625.545105 533.937073,623.718506 533.937073,621.517944 
	C525.221924,621.517944 516.689026,621.517944 507.607147,621.517944 
	C507.607147,623.981506 507.607147,626.270691 507.606934,629.051636 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M192.034454,540.004517 
	C192.034470,557.776428 192.034470,575.049561 192.034470,592.478516 
	C200.964096,592.478516 209.367950,592.478516 218.295563,592.478516 
	C218.295563,589.071167 218.295532,585.945312 218.295563,582.819458 
	C218.295792,564.828491 218.284683,546.837463 218.302765,528.846497 
	C218.308594,523.039734 219.089752,522.241882 224.924072,522.173889 
	C230.254028,522.111755 235.585648,522.119934 240.915817,522.172180 
	C246.878143,522.230591 247.773422,523.148132 247.776794,529.232178 
	C247.792389,557.384766 247.783798,585.537354 247.783829,613.689941 
	C247.783859,636.678467 247.784760,659.666931 247.783295,682.655457 
	C247.782745,691.089661 247.780136,691.090027 239.139282,691.091064 
	C234.308365,691.091614 229.459244,690.829163 224.651627,691.163879 
	C219.807648,691.501160 218.181595,689.617676 218.224136,684.847717 
	C218.396378,665.525574 218.295654,646.200989 218.295654,626.877319 
	C218.295654,625.224548 218.295654,623.571777 218.295654,621.531738 
	C209.595245,621.531738 201.194992,621.531738 192.034424,621.531738 
	C192.034424,623.085571 192.034439,624.833435 192.034424,626.581360 
	C192.034302,646.071594 191.931702,665.562805 192.111160,685.051392 
	C192.152420,689.530884 190.859421,691.433838 186.144440,691.168884 
	C180.332367,690.842224 174.472443,690.828247 168.662384,691.172119 
	C163.854935,691.456665 162.433578,689.322083 162.726822,684.978210 
	C162.905945,682.325012 162.758545,679.649780 162.758545,676.984436 
	C162.758484,627.842346 162.756104,578.700317 162.761383,529.558228 
	C162.762115,522.720032 163.285172,522.197937 170.155930,522.165039 
	C175.486450,522.139526 180.818970,522.245667 186.147324,522.135437 
	C190.268997,522.050232 192.375137,523.562927 192.085388,528.014709 
	C191.837067,531.829956 192.034286,535.674194 192.034454,540.004517 
z"/>
            <path fill="#F2B40A" opacity="1.000000" stroke="none"
                d="
M2696.117676,663.000000 
	C2696.117188,670.831665 2696.032715,678.164734 2696.149170,685.494507 
	C2696.211182,689.399963 2694.914307,691.340271 2690.631348,691.152283 
	C2684.644287,690.889343 2678.628174,690.888733 2672.641357,691.152527 
	C2668.313721,691.343201 2666.762207,689.799133 2666.801270,685.401489 
	C2666.973145,666.074036 2666.875488,646.744202 2666.875488,627.415222 
	C2666.875488,625.589661 2666.875488,623.764099 2666.875488,621.538574 
	C2658.120605,621.538574 2649.560547,621.538574 2640.264404,621.538574 
	C2640.264404,623.203796 2640.264648,624.966492 2640.264648,626.729187 
	C2640.264404,646.224792 2640.146484,665.721680 2640.349609,685.215149 
	C2640.397949,689.863525 2638.834229,691.424500 2634.258057,691.166138 
	C2628.444336,690.837952 2622.586670,690.859375 2616.770020,691.158813 
	C2612.235107,691.392273 2610.758057,689.318604 2611.000977,685.223938 
	C2611.050293,684.393799 2611.005859,683.558044 2611.005859,682.724915 
	C2611.005615,632.069641 2611.004639,581.414307 2611.006348,530.759033 
	C2611.006592,522.564880 2611.414307,522.171936 2619.853760,522.165894 
	C2624.352783,522.162659 2628.851807,522.147461 2633.350830,522.169922 
	C2639.718750,522.201721 2640.256836,522.722046 2640.260254,528.926208 
	C2640.270264,548.088562 2640.264404,567.250916 2640.264404,586.413269 
	C2640.264404,588.231934 2640.264404,590.050537 2640.264404,592.320007 
	C2649.097168,592.320007 2657.637207,592.320007 2666.875488,592.320007 
	C2666.875488,590.645325 2666.875244,588.884277 2666.875244,587.123230 
	C2666.875732,567.460999 2666.982178,547.797668 2666.795166,528.137268 
	C2666.753418,523.754517 2668.383545,522.069946 2672.580322,522.144653 
	C2678.243652,522.245544 2683.911377,522.108154 2689.575684,522.183777 
	C2695.207520,522.258911 2696.110840,523.231567 2696.112061,529.029724 
	C2696.121826,573.519836 2696.117676,618.009888 2696.117676,663.000000 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M267.863281,658.933105 
	C267.862122,624.310913 267.761749,590.178162 267.961548,556.047241 
	C267.994263,550.457520 268.569458,544.626038 270.260162,539.343628 
	C273.471893,529.309143 281.329651,523.723083 291.537628,523.102478 
	C304.110077,522.338257 316.789093,522.420776 329.375610,523.056396 
	C341.270660,523.657043 350.386780,532.872559 352.017548,544.754333 
	C352.625946,549.187134 352.904846,553.698425 352.914642,558.174805 
	C352.986938,591.307861 353.225037,624.445007 352.740662,657.571106 
	C352.634674,664.820801 350.871674,672.477112 348.004059,679.142700 
	C344.676971,686.876343 336.766937,690.272522 328.781250,690.731934 
	C316.512207,691.437805 304.069397,691.815247 291.882263,690.562500 
	C277.055725,689.038391 269.877960,680.415894 268.319611,665.393311 
	C268.113739,663.408875 268.013397,661.413452 267.863281,658.933105 
M324.754333,656.817444 
	C324.874237,654.661011 325.096771,652.504639 325.098541,650.348145 
	C325.121948,622.044678 325.114288,593.741211 325.114136,565.437744 
	C325.114075,550.937866 324.108215,549.946716 309.435242,549.985352 
	C298.422668,550.014343 296.389862,552.048767 296.386292,563.153259 
	C296.377014,592.289185 296.374329,621.425110 296.403137,650.561035 
	C296.405121,652.544312 296.683258,654.527954 296.844788,656.510437 
	C297.226471,661.195007 300.042633,663.257263 304.470825,663.342896 
	C308.793549,663.426636 313.121033,663.376526 317.444275,663.283997 
	C321.189941,663.203918 323.790314,661.527649 324.754333,656.817444 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M1691.942627,658.682922 
	C1694.139404,660.262451 1696.086304,662.162781 1698.265381,662.482971 
	C1702.180298,663.058228 1706.235229,662.732117 1710.230713,662.695801 
	C1715.084961,662.651611 1717.523926,659.955688 1717.961426,655.296387 
	C1718.116577,653.643127 1718.060791,651.967834 1718.060913,650.302551 
	C1718.065552,610.312805 1718.062012,570.323120 1718.066650,530.333374 
	C1718.067505,523.358337 1719.191406,522.213196 1726.099121,522.165955 
	C1730.431274,522.136353 1734.764038,522.118713 1739.095703,522.170959 
	C1745.178833,522.244385 1746.673950,523.749878 1746.686646,529.971008 
	C1746.720337,546.466736 1746.698364,562.962524 1746.698242,579.458313 
	C1746.697998,605.618286 1746.994995,631.783875 1746.497803,657.934387 
	C1746.365601,664.889343 1744.814697,672.232544 1742.088501,678.617615 
	C1738.701172,686.550903 1730.820923,690.339844 1722.618774,690.701721 
	C1709.522705,691.279480 1696.261475,691.421265 1683.263916,689.988892 
	C1670.343384,688.565063 1662.587036,679.117310 1662.218750,665.971680 
	C1661.626709,644.833069 1661.622681,623.675842 1661.532471,602.525818 
	C1661.431030,578.699036 1661.498535,554.871521 1661.515503,531.044312 
	C1661.520996,523.220764 1662.604980,522.179932 1670.516724,522.162048 
	C1674.515747,522.153015 1678.514648,522.147400 1682.513672,522.163086 
	C1689.940308,522.192139 1690.952881,523.178162 1690.953735,530.426208 
	C1690.958130,570.582581 1690.941040,610.738892 1690.991943,650.895203 
	C1690.994995,653.361023 1691.516846,655.826111 1691.942627,658.682922 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M428.845825,647.895142 
	C428.845764,640.756104 428.845764,634.101746 428.845764,627.185608 
	C413.567322,622.136414 398.434753,617.103333 383.279755,612.138611 
	C373.852539,609.050415 372.881134,607.913330 372.995087,597.899719 
	C373.190094,580.759338 372.989349,563.590088 373.964844,546.490601 
	C374.764587,532.472046 384.344757,523.593933 398.411865,522.989807 
	C410.182098,522.484436 422.015228,522.431702 433.777496,523.027527 
	C446.502197,523.672119 455.790680,532.438171 457.063721,545.009827 
	C458.050018,554.750061 457.812134,564.615662 458.078186,574.426636 
	C458.163116,577.558838 456.381287,578.984436 453.411469,579.009827 
	C446.750275,579.066772 440.088501,579.083740 433.427094,579.066833 
	C430.099030,579.058350 428.711670,577.332825 428.813354,573.997253 
	C428.955353,569.337341 428.996582,564.663330 428.801910,560.007019 
	C428.524963,553.382141 426.122772,551.100403 419.568390,550.766113 
	C403.861023,549.964905 402.230499,551.495056 402.230469,567.036316 
	C402.230469,572.533508 402.388092,578.037109 402.167236,583.525391 
	C402.047699,586.496033 403.000488,587.933899 405.913361,588.853882 
	C420.345673,593.412720 434.702972,598.208313 449.098663,602.883606 
	C456.539337,605.300171 458.157257,607.300415 458.078339,615.135925 
	C457.905640,632.278198 458.201202,649.454651 457.179352,666.549866 
	C456.324341,680.853943 448.024292,689.644104 433.858917,690.692505 
	C420.823486,691.657349 407.555756,691.206482 394.523773,689.971313 
	C383.301361,688.907654 375.539673,680.788025 374.251831,669.669312 
	C373.088440,659.624817 373.312042,649.415955 373.017334,639.276855 
	C372.926910,636.165405 374.776093,634.813049 377.776794,634.816895 
	C384.439941,634.825378 391.103302,634.843811 397.766205,634.802490 
	C401.234619,634.781006 402.392456,636.534058 402.270721,639.836792 
	C402.105194,644.328247 402.084686,648.837097 402.275055,653.326904 
	C402.567871,660.231934 404.964142,662.500732 411.802368,662.770020 
	C412.634094,662.802795 413.467987,662.781494 414.300873,662.784241 
	C427.671265,662.828125 428.848114,661.662598 428.845825,647.895142 
z"/>
            <path fill="#F2B50B" opacity="1.000000" stroke="none"
                d="
M598.151978,610.156006 
	C604.124451,582.614807 610.122803,555.506592 615.787598,528.328918 
	C616.782471,523.555603 618.954651,521.971436 623.564758,522.100769 
	C631.557495,522.325012 639.561523,522.219727 647.559692,522.142029 
	C651.269287,522.105957 653.240295,523.477844 654.075867,527.382263 
	C665.245972,579.575806 676.567200,631.737000 687.814636,683.914062 
	C689.200623,690.343445 688.513977,691.082214 681.902039,691.088196 
	C676.069458,691.093445 670.231201,690.933594 664.406433,691.146729 
	C660.821777,691.277893 659.416687,689.759033 658.829102,686.363647 
	C657.383667,678.010376 655.452271,669.739136 654.098267,661.373108 
	C653.612000,658.368408 652.432556,657.493408 649.585754,657.525940 
	C639.755005,657.638184 629.921692,657.619324 620.090332,657.537781 
	C617.485291,657.516113 616.313293,658.313599 615.859192,661.110901 
	C614.501160,669.476074 612.562927,677.748474 611.260620,686.120728 
	C610.628784,690.183411 608.712341,691.313110 604.882690,691.154602 
	C598.893799,690.906738 592.886841,691.110657 586.887756,691.082642 
	C581.577515,691.057800 580.970581,690.418640 582.164062,684.710938 
	C585.806335,667.292480 589.594666,649.904541 593.331421,632.505859 
	C594.902344,625.190918 596.486328,617.878723 598.151978,610.156006 
M646.838684,626.417542 
	C643.056030,605.728027 639.273315,585.038513 635.490662,564.349060 
	C635.100952,564.395203 634.711304,564.441345 634.321594,564.487488 
	C630.204529,587.059326 626.087524,609.631165 621.929626,632.426819 
	C630.995789,632.426819 639.238892,632.426819 647.798218,632.426819 
	C647.497498,630.483582 647.247437,628.867859 646.838684,626.417542 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M120.437805,522.165283 
	C126.057892,522.162781 131.224457,522.128967 136.390442,522.169739 
	C143.399368,522.225098 144.528625,523.839600 141.888596,530.218323 
	C132.212906,553.596313 122.543129,576.976929 112.734779,600.299255 
	C111.361160,603.565491 111.134941,606.298645 112.576889,609.714478 
	C122.673973,633.633606 132.529221,657.654968 142.448517,681.649109 
	C143.082794,683.183472 143.667313,684.744446 144.166183,686.327271 
	C145.060608,689.165161 144.160736,691.016541 141.009903,691.048279 
	C133.344727,691.125671 125.658417,691.363892 118.027023,690.849243 
	C116.257622,690.729980 113.936775,688.165466 113.122536,686.205566 
	C107.248795,672.066956 101.700783,657.793152 96.037514,643.566956 
	C95.555084,642.355103 94.985275,641.177979 93.943253,638.828430 
	C92.735985,641.532410 91.845604,643.347534 91.101936,645.221008 
	C85.758934,658.681030 80.311295,672.102112 75.204247,685.651489 
	C73.656456,689.757874 71.361519,691.376282 67.022507,691.160828 
	C61.203941,690.871887 55.360188,691.098816 49.527283,691.087646 
	C43.205082,691.075562 42.173233,689.635620 44.573498,683.602478 
	C47.834023,675.407043 51.287876,667.288574 54.650860,659.133850 
	C61.439522,642.672363 68.358849,626.262085 74.867287,609.690491 
	C75.888008,607.091553 75.936729,603.393738 74.904221,600.817505 
	C65.615440,577.640808 55.994129,554.597351 46.448803,531.523682 
	C43.196239,523.661377 44.155121,522.183167 52.675373,522.162781 
	C57.175034,522.151978 61.686184,522.362976 66.171432,522.108521 
	C71.383698,521.812866 74.318436,523.727905 76.195839,528.885681 
	C81.202904,542.641602 86.795418,556.184509 92.172455,569.805298 
	C92.581635,570.841858 93.126396,571.824829 94.072266,573.803833 
	C97.017654,566.381775 99.629547,559.842224 102.208908,553.289856 
	C105.501190,544.926575 108.906746,536.603760 111.982880,528.161255 
	C113.420334,524.216125 115.674454,521.978088 120.437805,522.165283 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M1447.820190,689.066833 
	C1447.494995,686.845093 1447.205933,685.035156 1447.205078,683.225037 
	C1447.180664,632.258301 1447.184204,581.291626 1447.187012,530.324890 
	C1447.187500,522.741638 1447.769775,522.162842 1455.445435,522.160706 
	C1478.263916,522.154419 1501.082275,522.154480 1523.900757,522.160583 
	C1531.738525,522.162720 1531.841064,522.272278 1531.845459,529.840820 
	C1531.848267,534.504456 1531.849609,539.168030 1531.845581,543.831665 
	C1531.839722,550.856201 1531.837524,550.862000 1525.032104,550.863708 
	C1510.208496,550.867493 1495.384766,550.844604 1480.561279,550.888672 
	C1478.563232,550.894592 1475.902832,550.097961 1475.903931,553.642944 
	C1475.907715,566.271545 1475.905396,578.900146 1475.905396,592.078979 
	C1478.045166,592.209839 1479.794067,592.404663 1481.543457,592.409485 
	C1492.369751,592.439209 1503.197021,592.516785 1514.021606,592.378357 
	C1517.810791,592.329895 1519.558594,593.725830 1519.491089,597.591858 
	C1519.386597,603.585999 1519.383179,609.585144 1519.505127,615.578796 
	C1519.587646,619.622742 1517.809570,621.232117 1513.786743,621.184875 
	C1502.961914,621.057800 1492.134766,621.134216 1481.308472,621.153870 
	C1479.687866,621.156860 1478.067627,621.288940 1476.177246,621.373352 
	C1476.177246,635.131836 1476.177246,648.556580 1476.177246,662.780945 
	C1477.970093,662.780945 1479.721680,662.780884 1481.473267,662.780884 
	C1496.296875,662.781311 1511.121948,662.894836 1525.943359,662.714294 
	C1530.468384,662.659241 1532.210327,664.166077 1531.929810,668.810608 
	C1531.579102,674.618896 1531.752563,680.466553 1531.883423,686.293152 
	C1531.956665,689.558716 1530.989258,691.158081 1527.354126,691.143188 
	C1502.370972,691.040833 1477.386841,691.116699 1452.403564,691.020569 
	C1450.930542,691.014893 1449.461548,690.015503 1447.820190,689.066833 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M836.712769,522.158752 
	C841.932861,521.723450 844.310974,523.359131 843.914062,528.658020 
	C843.504395,534.127197 843.609314,539.661926 843.891907,545.147217 
	C844.115295,549.484436 842.595703,551.011047 838.176758,550.947815 
	C823.180176,550.733337 808.176880,550.993713 793.180298,550.778992 
	C789.142273,550.721191 787.644836,551.712036 787.766785,556.007812 
	C788.064636,566.499084 788.043457,577.009155 787.772949,587.501892 
	C787.668274,591.560181 789.055481,592.585388 792.913696,592.503784 
	C803.741882,592.274719 814.581848,592.591797 825.409363,592.347656 
	C830.053040,592.242981 831.667480,594.073303 831.495605,598.512573 
	C831.289429,603.837769 831.501526,609.177795 831.431885,614.510071 
	C831.353333,620.526184 830.759338,621.114319 824.812134,621.133789 
	C814.312500,621.168213 803.812744,621.134705 793.312988,621.153748 
	C791.685791,621.156738 790.058899,621.287781 788.162109,621.371521 
	C788.162109,635.120972 788.162109,648.551025 788.162109,662.780945 
	C789.953552,662.780945 791.705750,662.780945 793.457947,662.780945 
	C807.957581,662.781006 822.457153,662.769226 836.956787,662.786377 
	C843.755798,662.794373 843.813904,662.875427 843.821716,669.852783 
	C843.827942,675.352661 843.718140,680.855225 843.862000,686.351318 
	C843.949219,689.684143 842.839417,691.156677 839.266968,691.142456 
	C814.268005,691.042847 789.268250,691.041260 764.269287,691.141357 
	C760.489563,691.156494 759.187866,689.345703 759.170532,686.000488 
	C759.141174,680.334167 759.158142,674.667480 759.158081,669.000977 
	C759.157715,623.002197 759.157349,577.003418 759.158447,531.004639 
	C759.158630,522.482849 759.490540,522.159668 768.249329,522.158936 
	C790.915405,522.157043 813.581482,522.158386 836.712769,522.158752 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M1266.507690,664.682983 
	C1266.728638,672.265198 1266.681396,679.431763 1266.861084,686.592712 
	C1266.950073,690.145203 1265.366577,691.150940 1262.019775,691.138916 
	C1237.187256,691.049316 1212.353760,691.013550 1187.521851,691.156006 
	C1182.661865,691.183899 1182.140015,688.463440 1182.145264,684.752930 
	C1182.173706,664.586670 1182.157959,644.420410 1182.157959,624.254150 
	C1182.157837,592.921448 1182.155762,561.588745 1182.159790,530.256042 
	C1182.160767,522.846985 1182.809326,522.165833 1189.998047,522.162476 
	C1213.164185,522.151733 1236.330444,522.150208 1259.496582,522.163574 
	C1266.549194,522.167664 1266.814575,522.456360 1266.821899,529.472778 
	C1266.827637,534.972656 1266.685181,540.477234 1266.870483,545.970886 
	C1266.995361,549.674316 1265.499756,550.948669 1261.853638,550.918823 
	C1246.521729,550.793274 1231.186157,550.991882 1215.856201,550.777527 
	C1211.907227,550.722290 1210.673218,551.833496 1210.774414,555.831299 
	C1211.040039,566.324402 1211.076904,576.835022 1210.761841,587.325378 
	C1210.630005,591.713867 1212.274170,592.592651 1216.238037,592.503723 
	C1226.732422,592.268433 1237.235840,592.408203 1247.735596,592.430969 
	C1253.915649,592.444397 1254.372437,592.864746 1254.435181,598.837769 
	C1254.492798,604.336975 1254.332275,609.839966 1254.468750,615.336304 
	C1254.574585,619.596313 1252.761108,621.261414 1248.479492,621.199341 
	C1236.982178,621.032715 1225.480713,621.140076 1213.980957,621.153564 
	C1213.176636,621.154480 1212.372559,621.278015 1211.226318,621.372803 
	C1211.226318,635.124512 1211.226318,648.665466 1211.226318,662.780579 
	C1216.217163,662.780579 1221.003662,662.780518 1225.790161,662.780579 
	C1237.289917,662.780762 1248.790527,662.710022 1260.288574,662.847900 
	C1262.308960,662.872009 1264.318604,663.770325 1266.507690,664.682983 
z"/>
            <path fill="#F2B50C" opacity="1.000000" stroke="none"
                d="
M2015.690186,557.084595 
	C2015.690063,567.234253 2015.967529,576.906494 2015.575439,586.551514 
	C2015.373047,591.528625 2017.108643,592.683044 2021.784912,592.530823 
	C2032.101196,592.194824 2042.439087,592.577637 2052.761719,592.357971 
	C2057.352539,592.260254 2059.556396,593.527039 2059.226318,598.570496 
	C2058.856934,604.209656 2058.984131,609.897400 2059.192383,615.553040 
	C2059.344482,619.684814 2057.589355,621.220520 2053.582031,621.178223 
	C2042.922852,621.065918 2032.261719,621.142090 2021.601318,621.143188 
	C2019.817017,621.143372 2018.032715,621.143188 2015.972168,621.143188 
	C2015.972168,635.138916 2015.972168,648.564453 2015.972168,662.782043 
	C2017.814453,662.782043 2019.564941,662.782043 2021.315308,662.782043 
	C2035.973267,662.782104 2050.633057,662.907776 2065.288330,662.708923 
	C2069.930420,662.645996 2072.020508,664.035156 2071.753174,668.963989 
	C2071.437500,674.776794 2071.641113,680.619995 2071.689941,686.449463 
	C2071.717529,689.733948 2070.447266,691.165466 2066.913818,691.149597 
	C2041.929077,691.037109 2016.943359,691.049011 1991.958374,691.137024 
	C1988.499146,691.149170 1987.113281,689.568604 1986.955444,686.409241 
	C1986.905640,685.412109 1986.935181,684.410889 1986.935059,683.411499 
	C1986.934448,632.275085 1986.932983,581.138611 1986.936401,530.002197 
	C1986.936768,522.837952 1987.564209,522.169434 1994.483154,522.165405 
	C2017.802734,522.151917 2041.122314,522.151306 2064.441895,522.165771 
	C2071.152344,522.169922 2071.656738,522.675293 2071.676514,529.141541 
	C2071.693359,534.638245 2071.578125,540.137390 2071.709717,545.630981 
	C2071.801025,549.427429 2070.325928,550.965332 2066.393555,550.925598 
	C2051.404053,550.773987 2036.408447,551.046692 2021.422974,550.752991 
	C2016.792114,550.662231 2014.920532,552.006348 2015.690186,557.084595 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M2798.615234,429.325714 
	C2790.131104,424.703949 2781.959717,420.275635 2773.099365,415.473999 
	C2785.652832,411.196014 2797.635010,407.125671 2809.608887,403.029877 
	C2854.770996,387.581451 2899.922852,372.102081 2945.096191,356.686676 
	C2956.885986,352.663361 2968.716553,348.755127 2980.578125,344.948792 
	C2984.707031,343.623871 2988.090576,341.998932 2986.931641,335.993073 
	C3002.148926,344.306824 3011.305176,357.058411 3020.249023,370.765228 
	C3007.497803,375.155670 2995.111572,379.435333 2982.715088,383.686310 
	C2929.224854,402.029205 2875.720947,420.332031 2822.263184,438.768463 
	C2818.471680,440.076080 2815.487305,440.052673 2812.118652,437.600433 
	C2807.962891,434.575348 2803.345703,432.184265 2798.615234,429.325714 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M2793.706055,576.270264 
	C2795.361816,599.937378 2796.957275,623.154358 2798.555420,646.414246 
	C2788.979736,649.716797 2780.208984,652.777466 2771.402344,655.731140 
	C2770.362549,656.079956 2768.979004,656.208252 2768.003418,655.817810 
	C2760.625977,652.864136 2753.310547,649.755371 2745.700684,646.580383 
	C2753.036865,632.166565 2757.664307,617.322815 2760.013672,601.747498 
	C2763.646973,577.662476 2762.731445,553.614258 2759.500244,529.595398 
	C2755.807129,502.145477 2748.980225,475.404236 2740.724121,449.017334 
	C2739.752441,445.911713 2740.020996,443.802246 2742.253662,441.423004 
	C2747.367188,435.973328 2752.218506,430.277527 2757.902832,423.862030 
	C2762.410156,436.691895 2767.000488,448.729706 2770.880371,460.992310 
	C2782.718994,498.410522 2789.568359,536.847656 2793.706055,576.270264 
z"/>
            <path fill="#F2B50D" opacity="1.000000" stroke="none"
                d="
M2622.852783,133.036011 
	C2621.017334,132.194717 2619.181641,131.353424 2617.194092,130.293274 
	C2627.493896,131.206070 2637.946045,132.337708 2648.707520,133.912430 
	C2649.016846,134.355515 2649.001953,134.823624 2648.571777,134.849792 
	C2641.073730,133.891953 2634.015137,132.825775 2626.928955,131.998550 
	C2625.628418,131.846710 2624.214355,132.665329 2622.852783,133.036011 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M2658.637207,139.402069 
	C2660.762695,142.314224 2662.887939,145.226425 2665.123047,148.460403 
	C2665.058594,148.951263 2664.884521,149.120346 2664.206543,149.319473 
	C2661.671875,146.344269 2659.641602,143.339020 2657.872559,140.106018 
	C2658.301270,139.719543 2658.469238,139.560822 2658.637207,139.402069 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M2654.404785,134.448639 
	C2655.722168,135.902847 2657.039551,137.357086 2658.497070,139.106720 
	C2658.469238,139.560822 2658.301270,139.719543 2657.619629,139.910675 
	C2655.961182,138.432205 2654.816650,136.921295 2653.860352,135.173798 
	C2654.167236,134.774368 2654.285889,134.611526 2654.404785,134.448639 
z"/>
            <path fill="#F2B40B" opacity="1.000000" stroke="none"
                d="
M2649.001953,134.823608 
	C2649.001953,134.823624 2649.016846,134.355515 2649.028076,134.121582 
	C2650.591553,133.969681 2652.143799,134.051712 2654.050293,134.291199 
	C2654.285889,134.611526 2654.167236,134.774368 2653.470215,135.159119 
	C2651.594971,135.195221 2650.298584,135.009415 2649.001953,134.823608 
z"/>
            <path fill="#FEFCF7" opacity="1.000000" stroke="none"
                d="
M2648.571777,134.849777 
	C2650.298584,135.009415 2651.594971,135.195221 2653.281738,135.395691 
	C2654.816650,136.921295 2655.961182,138.432205 2657.358398,140.138443 
	C2659.641602,143.339020 2661.671875,146.344269 2663.946289,149.573822 
	C2673.114014,162.640411 2681.896240,175.584610 2691.024902,188.279709 
	C2695.262207,194.172562 2698.933838,200.218048 2700.186768,207.425339 
	C2703.050537,223.897324 2712.468994,236.848969 2722.078613,249.909149 
	C2745.640869,281.932312 2768.807617,314.246521 2792.121582,346.452026 
	C2797.039062,353.245361 2797.007080,353.664215 2791.494385,361.374390 
	C2784.108398,350.556000 2776.808350,339.883911 2769.528809,329.197968 
	C2727.466309,267.454742 2685.423584,205.698105 2643.279297,144.010910 
	C2641.964111,142.085648 2639.813965,140.475800 2637.705322,139.399933 
	C2633.119141,137.059738 2628.308105,135.160065 2623.220947,133.058136 
	C2624.214355,132.665329 2625.628418,131.846710 2626.928955,131.998550 
	C2634.015137,132.825775 2641.073730,133.891953 2648.571777,134.849777 
z"/>
            <path fill="#FEFCF7" opacity="1.000000" stroke="none"
                d="
M2629.142578,259.137390 
	C2611.826904,269.938843 2594.555908,280.812378 2577.186768,291.526886 
	C2540.669922,314.052826 2504.114502,336.516144 2467.525635,358.925201 
	C2465.044189,360.444855 2463.726318,362.041565 2463.553467,365.118317 
	C2463.023438,374.539307 2462.122314,383.939423 2461.309570,394.044769 
	C2457.082520,391.584625 2453.324463,389.557068 2449.779785,387.207062 
	C2449.021484,386.704163 2448.669922,385.003448 2448.755615,383.903259 
	C2449.453369,374.941986 2450.142090,365.972900 2451.238281,357.055878 
	C2451.450195,355.332092 2453.074463,353.170288 2454.647705,352.315125 
	C2490.735107,332.699768 2526.906982,313.239319 2563.061035,293.746490 
	C2584.670898,282.095398 2606.277588,270.438354 2628.354004,258.802643 
	C2628.822266,258.821289 2629.142578,259.137390 2629.142578,259.137390 
z"/>
            <path fill="#FEFCF7" opacity="1.000000" stroke="none"
                d="
M2815.035156,340.877838 
	C2823.673584,342.477509 2826.433105,347.326019 2823.011719,354.902313 
	C2817.811035,366.419098 2812.411133,377.848389 2806.933594,389.236816 
	C2804.243408,394.829437 2798.927979,396.982147 2794.265869,394.758484 
	C2789.392578,392.434174 2787.616699,387.202698 2790.238770,381.544556 
	C2795.621582,369.928833 2801.203125,358.404388 2806.776123,346.877960 
	C2808.351562,343.619904 2810.507080,340.915100 2815.035156,340.877838 
M2794.604980,390.990143 
	C2796.806641,390.516754 2799.352539,390.538208 2801.057617,389.351166 
	C2801.852051,388.798218 2801.584473,385.592407 2800.792236,384.136749 
	C2799.396973,381.573395 2796.784912,381.164276 2794.430176,383.009583 
	C2791.573730,385.247803 2791.467773,387.941223 2794.604980,390.990143 
M2804.158936,372.781097 
	C2806.245605,371.990875 2808.794434,371.663635 2810.234863,370.226105 
	C2811.021729,369.440918 2810.550293,366.158386 2809.520264,365.129517 
	C2808.448242,364.058838 2805.868652,363.745514 2804.216309,364.162964 
	C2800.653320,365.063110 2800.472656,368.468536 2804.158936,372.781097 
M2815.386475,344.909546 
	C2811.396973,345.161865 2809.502686,347.710632 2810.587646,351.131287 
	C2811.069336,352.650116 2814.216797,353.846893 2816.292236,354.112183 
	C2817.304443,354.241608 2819.790527,351.634125 2819.583252,350.730591 
	C2819.110596,348.671631 2817.387207,346.899689 2815.386475,344.909546 
z"/>
            <path fill="#FEFCF7" opacity="1.000000" stroke="none"
                d="
M2630.008789,258.009033 
	C2630.511475,257.726471 2631.013916,257.443909 2631.516602,257.161316 
	C2631.175781,257.559875 2630.834961,257.958527 2630.234863,258.169128 
	C2629.975342,257.981110 2630.008789,258.009003 2630.008789,258.009033 
z"/>
            <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="
M2818.067139,334.940308 
	C2818.458008,335.077209 2818.658691,335.410309 2818.859131,335.743439 
	C2818.574707,335.793396 2818.290283,335.843323 2817.762451,335.721375 
	C2817.638428,335.411835 2817.757568,335.274200 2818.067139,334.940308 
z"/>
            <path fill="#FEFCF7" opacity="1.000000" stroke="none"
                d="
M2628.671387,258.654327 
	C2628.837158,258.335022 2629.153809,258.182678 2629.739746,258.019653 
	C2630.008789,258.009003 2629.975342,257.981110 2629.955566,257.968201 
	C2629.997070,258.193817 2630.095947,258.431641 2630.100586,258.671295 
	C2630.102295,258.766541 2629.894775,258.865692 2629.462402,259.050201 
	C2629.142578,259.137390 2628.822266,258.821289 2628.671387,258.654327 
z"/>
            <path fill="#FEFCF7" opacity="1.000000" stroke="none"
                d="
M2934.542480,505.485535 
	C2943.236084,532.455872 2940.616455,558.729065 2932.367676,584.844421 
	C2931.280518,588.285522 2929.347656,590.684509 2925.499268,589.409912 
	C2921.672119,588.142334 2921.457764,584.988159 2922.557373,581.594971 
	C2926.787842,568.542236 2929.508301,555.171082 2929.700928,541.451660 
	C2930.135742,510.482727 2917.587646,485.357758 2894.445068,465.246735 
	C2890.554688,461.866089 2886.385986,458.801910 2882.298584,455.653229 
	C2879.526123,453.517487 2877.604980,451.015961 2879.928711,447.630371 
	C2882.271973,444.216064 2885.253662,445.033264 2888.177979,447.111084 
	C2909.151855,462.012970 2925.774658,480.374084 2934.542480,505.485535 
z"/>
            <path fill="#FEFDF9" opacity="1.000000" stroke="none"
                d="
M3014.366455,423.619202 
	C3010.044922,420.191772 3005.968018,417.025208 3001.930908,413.808533 
	C2999.197266,411.630371 2998.253418,408.917664 3000.573975,406.006561 
	C3002.778564,403.240845 3005.479004,403.783752 3008.100830,405.646851 
	C3035.070312,424.811432 3054.431885,449.061646 3059.233887,482.853149 
	C3062.222900,503.885162 3058.961670,524.320496 3052.509521,544.350647 
	C3051.551025,547.325928 3049.442871,549.357056 3046.067139,548.266296 
	C3042.654297,547.163696 3041.670654,544.631836 3042.751221,541.128662 
	C3046.986816,527.398071 3049.949951,513.452515 3050.011475,498.981140 
	C3050.133545,470.319641 3039.055176,446.660919 3018.280029,427.269836 
	C3017.062256,426.133209 3015.845215,424.995789 3014.366455,423.619202 
z"/>
            <path fill="#FEFDF9" opacity="1.000000" stroke="none"
                d="
M3012.840088,556.765381 
	C3011.626709,560.776733 3009.536621,563.328186 3005.451904,561.769897 
	C3001.701172,560.339050 3001.825684,557.246033 3002.911865,553.827637 
	C3007.059570,540.769653 3009.790283,527.410522 3009.953369,513.677856 
	C3010.312012,483.499298 2998.303467,458.820435 2975.971436,438.942413 
	C2971.502686,434.964905 2966.668213,431.395660 2961.967529,427.681976 
	C2959.250244,425.535187 2958.022217,422.966736 2960.297852,419.957947 
	C2962.379639,417.205048 2965.149902,417.379669 2967.811768,419.249512 
	C2992.283936,436.439270 3010.720703,458.128540 3017.561768,487.959839 
	C3022.434082,509.204285 3020.317139,530.303162 3014.508789,551.128174 
	C3014.017334,552.889587 3013.464600,554.633850 3012.840088,556.765381 
z"/>
            <path fill="#FEFDF9" opacity="1.000000" stroke="none"
                d="
M2954.314941,473.740021 
	C2946.308594,461.836823 2936.472900,452.225006 2925.236816,443.991241 
	C2919.184814,439.556183 2917.827148,436.969757 2919.986572,433.831818 
	C2922.125000,430.725159 2925.413574,431.198059 2931.195068,435.468323 
	C2950.344971,449.612610 2965.608643,466.874481 2973.852295,489.566101 
	C2982.844971,514.319397 2981.349121,539.255249 2974.552002,564.194519 
	C2973.809570,566.918701 2973.444092,569.984009 2971.892090,572.174194 
	C2970.635986,573.946533 2967.739746,575.762512 2965.780273,575.557617 
	C2962.556885,575.220642 2961.569824,572.253296 2962.339600,569.002075 
	C2964.443604,560.112915 2967.117676,551.308044 2968.488525,542.305664 
	C2972.200439,517.930969 2968.299316,494.925659 2954.314941,473.740021 
z"/>
            <path fill="#FEFDF9" opacity="1.000000" stroke="none"
                d="
M2561.805664,626.790283 
	C2561.968262,636.506287 2562.214600,645.802368 2562.042725,655.090637 
	C2561.946533,660.279968 2559.391113,662.591736 2554.165771,662.731812 
	C2548.059082,662.895508 2541.944824,662.770020 2535.490234,662.770020 
	C2535.490234,648.880188 2535.490234,635.360168 2535.490234,621.230164 
	C2542.400635,621.230164 2549.335449,620.855164 2556.182373,621.465820 
	C2558.156494,621.641907 2559.877686,624.654724 2561.805664,626.790283 
z"/>
            <path fill="#FFFDFB" opacity="1.000000" stroke="none"
                d="
M2543.055176,550.735474 
	C2547.197998,550.773254 2550.857178,550.708679 2554.505859,550.874634 
	C2559.224365,551.089233 2561.981934,553.636108 2562.060791,558.396240 
	C2562.206543,567.201172 2562.186523,576.010986 2562.087158,584.817017 
	C2562.033203,589.588989 2559.214111,592.334717 2554.650391,592.573120 
	C2548.389893,592.900085 2542.099854,592.654846 2535.488525,592.654846 
	C2535.488525,578.650146 2535.488525,564.977051 2535.488525,550.735657 
	C2538.005615,550.735657 2540.286377,550.735657 2543.055176,550.735474 
z"/>
            <path fill="#FEFDF9" opacity="1.000000" stroke="none"
                d="
M1106.234619,642.999634 
	C1106.234619,635.564819 1106.234619,628.629822 1106.234619,621.190125 
	C1113.492310,621.190125 1120.251953,620.981995 1126.989868,621.274780 
	C1130.546753,621.429321 1132.915649,623.914001 1132.994507,627.475586 
	C1133.207520,637.086609 1133.210693,646.707825 1133.015991,656.319336 
	C1132.944214,659.860779 1130.698242,662.422546 1127.080200,662.570190 
	C1120.332886,662.845520 1113.566162,662.649292 1106.234497,662.649292 
	C1106.234497,656.023560 1106.234497,649.761536 1106.234619,642.999634 
z"/>
            <path fill="#FEFDF9" opacity="1.000000" stroke="none"
                d="
M1107.388916,550.973022 
	C1113.319946,550.786743 1118.814819,550.616760 1124.299194,550.785889 
	C1130.786743,550.985901 1133.075439,553.136414 1133.268188,559.549988 
	C1133.512695,567.695435 1133.427002,575.852783 1133.372803,584.004333 
	C1133.340942,588.796692 1131.093262,592.221802 1126.109497,592.499207 
	C1119.696289,592.856140 1113.248291,592.586060 1106.234619,592.586060 
	C1106.234619,580.136597 1106.208252,568.038574 1106.266113,555.940857 
	C1106.273804,554.339294 1106.710205,552.739868 1107.388916,550.973022 
z"/>
            <path fill="#FEFDF9" opacity="1.000000" stroke="none"
                d="
M908.917786,550.732666 
	C911.395020,550.816345 913.401794,550.780701 915.377991,551.009460 
	C919.143311,551.445374 921.781128,553.487183 921.824707,557.391113 
	C921.982483,571.528381 921.997681,585.669373 921.846375,599.806641 
	C921.804932,603.677185 919.174988,606.052246 915.417419,606.191284 
	C908.324036,606.453857 901.214111,606.267151 893.741211,606.267151 
	C893.741211,588.042603 893.741211,569.816101 893.741211,550.732727 
	C898.630737,550.732727 903.532166,550.732727 908.917786,550.732666 
z"/>
            <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="
M1028.040771,655.435425 
	C1027.348633,660.678284 1024.429810,662.763550 1019.762695,662.762146 
	C1013.782227,662.760376 1007.801697,662.761780 1001.423584,662.761780 
	C1001.423584,625.549255 1001.423584,588.536072 1001.423584,551.201782 
	C1008.366638,551.201782 1015.443542,550.918579 1022.481750,551.318115 
	C1026.145996,551.526062 1027.663086,554.711365 1027.958984,558.101562 
	C1028.218750,561.077759 1028.114014,564.088684 1028.113770,567.084229 
	C1028.110840,596.387817 1028.096069,625.691467 1028.040771,655.435425 
z"/>
            <path fill="#FFFDFB" opacity="1.000000" stroke="none"
                d="
M324.688995,657.239868 
	C323.790314,661.527649 321.189941,663.203918 317.444275,663.283997 
	C313.121033,663.376526 308.793549,663.426636 304.470825,663.342896 
	C300.042633,663.257263 297.226471,661.195007 296.844788,656.510437 
	C296.683258,654.527954 296.405121,652.544312 296.403137,650.561035 
	C296.374329,621.425110 296.377014,592.289185 296.386292,563.153259 
	C296.389862,552.048767 298.422668,550.014343 309.435242,549.985352 
	C324.108215,549.946716 325.114075,550.937866 325.114136,565.437744 
	C325.114288,593.741211 325.121948,622.044678 325.098541,650.348145 
	C325.096771,652.504639 324.874237,654.661011 324.688995,657.239868 
z"/>
            <path fill="#FEFCF7" opacity="1.000000" stroke="none"
                d="
M646.918030,626.834839 
	C647.247437,628.867859 647.497498,630.483582 647.798218,632.426819 
	C639.238892,632.426819 630.995789,632.426819 621.929626,632.426819 
	C626.087524,609.631165 630.204529,587.059326 634.321594,564.487488 
	C634.711304,564.441345 635.100952,564.395203 635.490662,564.349060 
	C639.273315,585.038513 643.056030,605.728027 646.918030,626.834839 
z"/>
            <path fill="#F2B50D" opacity="1.000000" stroke="none"
                d="
M2794.270996,390.826630 
	C2791.467773,387.941223 2791.573730,385.247803 2794.430176,383.009583 
	C2796.784912,381.164276 2799.396973,381.573395 2800.792236,384.136749 
	C2801.584473,385.592407 2801.852051,388.798218 2801.057617,389.351166 
	C2799.352539,390.538208 2796.806641,390.516754 2794.270996,390.826630 
z"/>
            <path fill="#F2B50D" opacity="1.000000" stroke="none"
                d="
M2803.839355,372.553955 
	C2800.472656,368.468536 2800.653320,365.063110 2804.216309,364.162964 
	C2805.868652,363.745514 2808.448242,364.058838 2809.520264,365.129517 
	C2810.550293,366.158386 2811.021729,369.440918 2810.234863,370.226105 
	C2808.794434,371.663635 2806.245605,371.990875 2803.839355,372.553955 
z"/>
            <path fill="#F2B50D" opacity="1.000000" stroke="none"
                d="
M2815.779053,344.960358 
	C2817.387207,346.899689 2819.110596,348.671631 2819.583252,350.730591 
	C2819.790527,351.634125 2817.304443,354.241608 2816.292236,354.112183 
	C2814.216797,353.846893 2811.069336,352.650116 2810.587646,351.131287 
	C2809.502686,347.710632 2811.396973,345.161865 2815.779053,344.960358 
z"/>
        </svg>

    );
}

export default SvgComponent;
